import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ViewChild,
  inject,
  Input,
  AfterViewInit,
} from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { FormHeaderElement } from 'src/app/shared/models/app-models/FormHeaderElementList.model';
import {
  MY_DATE_FORMAT,
  documentStatusPopulator,
} from '../../data/constants/Data';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendApiService } from 'src/app/core/services/backend-api';
import {
  FormStatus,
  IBudgetAllocForm,
  IItemToRequest,
  MyPurchaseForm,
  VendorTagging,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import {
  Subject,
  takeUntil,
  lastValueFrom,
  Observable,
  firstValueFrom,
  skip,
  BehaviorSubject,
  Subscription
} from 'rxjs';
import { Store } from '@ngrx/store';
import {
  updateFormStatus,
  updateFormType,
  updateWholeForm,
} from 'src/app/core/store/form.actions';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogState,
} from '@angular/material/dialog';
import { InfoDialogComponent } from 'src/app/shared/components/info-dialog/info-dialog.component';
import docStatus from 'src/app/data/constants/DocumentStatusCategory.json';
import {
  FileInformation,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models/';
import { FormTransformerPipe } from 'src/app/shared/pipes/form-transformer/form-transformer.pipe';
import {
  Attachment,
  AttachmentTypeIdEnum,
  CurrentWorkFlowHistory,
  SaveMyPurchase,
  SystemConfiguration,
} from 'src/app/shared/models/database-models';
import { AttachmentComponent, AttachmentData } from './attachments/attachment.component';
import moment from 'moment';
import docType from 'src/app/data/constants/DocumentType.json';
import PurchaseMode from 'src/app/data/constants/PurchaseMode.json'
import _, { isEqual, isNaN, isNumber, round } from 'lodash';
import { getOperatingBudgetAllocations, getTotalBudgetCost, getCapitalBudgetAllocationsWithFinancialYear, getOperatingBudgetAllocationsCWithFinancialYear, getCapitalAUCAllocations, getProjectBudgetAllocations } from '../shared/utils/derive-budget-allocations';
import { getCapitalAllocations } from '../shared/utils/derive-budget-allocations-for-ro'
import { BannerService, BannerType } from 'src/app/shared/services/banner.service';
import { RfsOutcome, RfsSourcingResponse } from 'src/app/shared/components/global-banner/dto/rfs-sourcing-response.model';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { doesNotMeetRfsCriteria } from '../shared/utils/check-rfs-criteria';
import { ValidationErrorCategory, ValidationErrorMessage } from 'src/app/shared/models/app-models/ValidationErrorMessage.model';
import { SystemConfigurationService } from 'src/app/core/services/systemConfiguration.service';
import { DeletedItemVendorsState } from 'src/app/core/store/DeletedItemVendors.reducer';
import { CurrencyExchange } from 'src/app/shared/models/database-models/CurrencyExchange.model';
import { addCurrencyExchange } from 'src/app/core/store/CurrencyExchange.action';
import { missingBudgetExpenditureUsage, missingBudgetFrequencyUsage, missingCostCenterFields, missingFundCenter, missingGLFields, missingProjectBudget, missingProjectCode } from 'src/app/shared/validators/budget-allocation-field-validators';
import { ValidationService } from 'src/app/shared/services/validation.service';
import { AttachmentTableInformation } from 'src/app/shared/models/app-models/FileInformation.model';
import { clearAttachmentStore, getAllAttachment } from 'src/app/core/store/attachment.action';
import { clearDeletedItemVendorStore, updateRfsOutcomes } from 'src/app/core/store/DeletedItemVendors.action';
import { AoActionDialogComponent } from '../approving-officer-page/approving-action-dialog/approving-action-dialog.component';
import { FormControl } from '@angular/forms';
import { clearTaggingStore } from 'src/app/core/store/TaggedVendors.action';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { environment } from 'src/environments/environment';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { RecommendingOfficersSelection } from 'src/app/shared/models/app-models/RecommendingOfficerReselection.model';
import { DroDialogComponent } from './dro-dialog/dro-dialog.component';
import { officerReselectionDto } from './dro-dialog/officer-reselection-dto.model';
import { isReadOnly } from 'src/app/core/services/permissions/isReadonly';
import { DatePipe } from '@angular/common';
import { OthersBudget } from "src/app/shared/models/sap-models/otherBudget";
import { WBSBudget } from "src/app/shared/models/sap-models/wbsBudget";
import { DocumentLock } from 'src/app/shared/models/database-models/DocumentLock';
import { RfsExtendLockDialogComponent } from './rfs-extend-lock-dialog/rfs-extend-lock-dialog.component';
import { RfsInfoDialogComponent } from './rfs-info-dialog/rfs-info-dialog.component';
import { TaggingState } from 'src/app/core/store/TaggedVendors.reducer';
import { itemListFrontendToBackendMapper } from '../shared/utils/format-form-data-for-save';
import { validateVendorsEmailRO } from "../shared/utils/validate-vendor-email";
import { AssignmentList, RfsService } from './rfs/rfs.service';
import { PEAssignmentListResponse } from 'src/app/shared/models/database-models/RFS.model';
import { TagItemVendorService } from './rfs/tag-item-vendor.service';
import { AlertType } from "src/app/shared/components/alert/alert.component";
import { SecurityClassificationId } from 'src/app/shared/models/database-models/SecurityClassification';
import { DocumentMainStatus, DocumentStatusToRemoveDIRP, DocumentSubStatus, DocumentSubStatusToRemoveDIRP, DocumentSubStatusToStrikeThroughDIRP } from 'src/app/shared/models/database-models/DocumentStatus.model';
import { RfqOutputService } from './rfq-output/rfq-output.service';
import { FileService } from 'src/app/shared/services/file.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDrawer } from '@angular/material/sidenav';
import { ItemErrorService, ItemTabName, ItemFieldName } from 'src/app/shared/services/itemError.service';
import { rfqListDropDown } from 'src/app/shared/models/app-models/DropDown.model';
import { pageName } from 'src/app/shared/services/page.service';
import { CreateRFQDialogComponent } from 'src/app/shared/components/create-rfq-dialog/create-rfq-dialog.component';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { CurrentWorkflowService } from '../shared/current-workflow/current-workflow.service';
import { decrementLoading, incrementLoading } from 'src/app/core/store/loading.action';
import { LoadingState } from 'src/app/core/store/loading.reducer';

@Component({
  selector: 'app-rfq',
  templateUrl: './mypurchase-form.component.html',
  styleUrls: ['./mypurchase-form.component.scss'],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {},
    },
    {
      provide: DatePipe,
    },
    ValidationService,
  ],
})
export class MyPurchaseFormComponent implements OnInit, OnDestroy {
  @ViewChild('attachment') attachmentComponent!: AttachmentComponent;
  @ViewChild('drawer', { static: false }) public drawer!: MatDrawer;
  @Input() drawerHandler!: MatDrawer;
  formStatus: FormHeaderElement[] = documentStatusPopulator;
  currentRoute: string[] = ['Purchase Modes'];
  breadCrumbFlow: string[] = ['Purchase Modes'];
  // store$: Observable<MyPurchaseForm>;
  form!: MyPurchaseForm;
  tabLabel: string = '';
  rfsLock: boolean = true;
  rfsLocked: boolean = false;
  setIntervalToCheckRfsLock: ReturnType<typeof setInterval> | null = null
  setIntervalForExtensionPrompt: ReturnType<typeof setInterval> | null = null
  extensionDialogRef: MatDialogRef<RfsExtendLockDialogComponent> | null = null
  infoDialogRef: MatDialogRef<RfsInfoDialogComponent> | null = null
  RODialogRef: MatDialogRef<RfsInfoDialogComponent> | null = null
  firstRequestToAcquireLockMade: boolean = false
  destroy$: Subject<boolean> = new Subject<boolean>();
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  validatedDraftMsgs: ValidationErrorMessage[] = [];
  shouldShowPEView: boolean = false;
  isPEChecked: boolean = false;
  peResponseObj?: PEAssignmentListResponse;
  docNo: string = ''
  recalled: boolean = false;
  openPeAssignmentList: boolean = false;
  currencyExchangeRates: CurrencyExchange[] = []
  rfsOutcomeResults?: RfsSourcingResponse
  //show loader when saving submitting and navigating to my Documents so it can load the appropriate status
  showLoader: boolean = true;
  docStatus: string = '';
  loggedInUser!: UserInformation;
  loggedInUsername: string = '';
  formStore!: Observable<MyPurchaseForm>;
  dpStore!: Observable<StoreDropdowns>;
  dpOptions!: StoreDropdowns;
  draftPopulated: boolean = false;
  mpNumber: string = '';
  docStatusCode: string = '';
  edited: boolean = false;
  tagged: boolean = false;
  showAssignmentBar: boolean = false;
  selectedIndex: number = Number(sessionStorage.getItem('currentTab'));; 
  purchaseType: string = '';
  updatedCurrentWorkflowHistory: CurrentWorkFlowHistory | null = null;
  isGenerateWorkflowError: boolean = false;
  onNavigateToItemVendor: Function;
  purchaseTypeString: string = 'Request For Quotation';
  activePage: string = 'Request For Quotation';
  readonly permissionData$: Observable<any>
  purchaseTypeMap = PurchaseTypeMap
  wasVendorsUpdated: boolean = false
  oldForm?: MyPurchaseForm
  taggedVendors: VendorTagging[] = []
  dagId: string = '';

  loaders: string[] = [];

  private mpNumberSubject = new BehaviorSubject<string | null>(null);
  public mpNumber$ = this.mpNumberSubject.asObservable();
  private loadingSubscription: Subscription = new Subscription();
  isLoadingGenerateWorkflow = false;


  // for refreshing
  @HostListener('window:beforeunload', ['$event']) unloadWarning(
    e: BeforeUnloadEvent
  ) {
    e.preventDefault();
    e.returnValue = true;
    return e;
  }

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private transformer: FormTransformerPipe,
    private permissionsService: PermissionsService,
    private store: Store<{
      form: MyPurchaseForm;
      dp: StoreDropdowns;
      user: UserInformation;
      deletedItemVendors: DeletedItemVendorsState;
      currency: CurrencyExchange[]
      tagging: VendorTagging[],
      loading: LoadingState
    }>,
    private backEndService: BackendApiService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<InfoDialogComponent>,
    private dialogRefCopy: MatDialogRef<DialogComponent>,
    private dialogRefDelete: MatDialogRef<DialogComponent>,
    private dialogConfRef: MatDialogRef<DialogComponent>,
    private formTransformer: FormTransformerPipe,
    private route: ActivatedRoute,
    private bannerService: BannerService,
    private systemConfigurationService: SystemConfigurationService,
    private validationService: ValidationService,
    private rfsService: RfsService,
    private tagItemVendorService: TagItemVendorService,
    private rfqOutputService: RfqOutputService,
    private fileService: FileService,
    private itemErrorService: ItemErrorService,
    private currencyService: CurrencyService,
    private currentWorkflowService: CurrentWorkflowService
  ) {
    this.loadingSubscription = this.store.select('loading').subscribe((loadingState) => {
      this.isLoadingGenerateWorkflow = loadingState.loadingStates['generateWorkflow'] > 0;
    });
    this.mpNumber = this.route.snapshot.params['id'].split(';')[0] as string;
    this.edited = this.route.snapshot.paramMap.get('edited') === 'true';
    this.tagged = this.route.snapshot.paramMap.get('tagged') === 'true';
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(';')[0] as string;
    this.onNavigateToItemVendor = this.prevTab.bind(this);
    //this.purchaseTypeString =  this.purchaseType == 'rfq' ? this.purchaseTypeString : 'Tender'
    this.permissionData$ = permissionsService.getService().pipe(takeUntil(this.destroy$))
    if (this.mpNumber && this.mpNumber != 'draft') {
      this.getPurchaseTypeString();
      this.activePage = this.mpNumber;
      this.getCurrentWorkflow();
    } else {
      this.getPurchaseTypeString();
      this.activePage = this.purchaseTypeString;
    }
    this.store.select('currency').pipe(takeUntil(this.destroy$)).subscribe((currency: CurrencyExchange[]) => {
      this.currencyExchangeRates = currency
    })
    this.store
      .select('tagging')
      .pipe(takeUntil(this.destroy$))
      .subscribe((tagging) => {
        let vendorTaggingSet = new Set();
        this.taggedVendors = (tagging as unknown as TaggingState).tags.filter(
          (tag) => {
            const tagString = JSON.stringify(tag);
            if (vendorTaggingSet.has(tagString)) {
              return false;
            }
            vendorTaggingSet.add(tagString);
            return true;
          }
        );
      });
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.dpOptions = dp;
      });
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserInformation) => {
        this.loggedInUser = user;
        this.loggedInUsername = user.userName;
      });
    this.store.select('deletedItemVendors').pipe(takeUntil(this.destroy$))
      .subscribe((deletedItem: DeletedItemVendorsState) => {
        if (deletedItem.rfsSourcingOutcomes !== null)
          this.checkAndGenerateRFSOutcomes(deletedItem.rfsSourcingOutcomes, deletedItem.deletedItemMappings)
      });
    // update form header by subscribing to changes in the store
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.oldForm = structuredClone(this.form)
        this.form = form;
        console.log('form object', this.form)
        this.checkIfVendorsUpdated(this.oldForm, form)
        this.form.documentStatusId == 15 ? this.showAssignmentBar = true : this.showAssignmentBar = false;
        this.formStatus = [
          new FormHeaderElement(
            'Created By:',
            this.dpOptions.UserList.find((user) => user.id == form.createdBy)
              ?.value ?? ''
          ),
          new FormHeaderElement(
            'Date created:',
            moment(form.CreatedOn).format(MY_DATE_FORMAT.display.dateInput) ??
            '-'
          ),
          new FormHeaderElement('Purchase Mode:', form.PurchaseTypeId ? PurchaseMode.find((mode) => mode.id == form.PurchaseTypeId)?.purchaseType : ''),
          new FormHeaderElement('Document No:', form.documentNo ?? '-'),
          new FormHeaderElement(
            'Document status:',
            docStatus.find(
              (statusName) =>
                statusName.DocumentStatusCatId ==
                form.documentStatusId?.toString()
            )?.['Name'] ?? ''
          ),
          new FormHeaderElement(
            'Workflow status:',
            docType.find(
              (statusName) =>
                statusName.DocumentStatusTypeId ==
                form.documentSubStatusId?.toString()
            )?.['Name'] == 'Draft'
              ? '-'
              : docType.find(
                (statusName) =>
                  statusName.DocumentStatusTypeId ==
                  form.documentSubStatusId?.toString()
              )?.['Name'] ?? ''
          ),
        ];

        if (PurchaseMode.find((mode) => mode.id == form.PurchaseTypeId)?.purchaseType == "Tender") {
          this.formStatus = this.formStatus.concat([
            new FormHeaderElement('Tender doc no:', form.TenderDocumentNumber ? form.TenderDocumentNumber : (docStatus.find(
              (statusName) =>
                statusName.DocumentStatusCatId ==
                form.documentStatusId?.toString()
            )?.['Name'].trim() == 'New' && docType.find(
              (statusName) =>
                statusName.DocumentStatusTypeId ==
                form.documentSubStatusId?.toString()
            )?.['Name'].trim() == 'New') ? '-' : 'To be generated'),
            new FormHeaderElement(),
            new FormHeaderElement('Contracting exec:', form.CE ? this.dpOptions.UserList.find((user) => user.id == form.CE)?.value : (docStatus.find(
              (statusName) =>
                statusName.DocumentStatusCatId ==
                form.documentStatusId?.toString()
            )?.['Name'].trim() == 'New' && docType.find(
              (statusName) =>
                statusName.DocumentStatusTypeId ==
                form.documentSubStatusId?.toString()
            )?.['Name'].trim() == 'New') ? '-' : 'To be assigned')
          ])
        }

        if (PurchaseMode.find((mode) => mode.id == form.PurchaseTypeId)?.purchaseType == "Direct Contracting") {
          this.formStatus = this.formStatus.concat([
            new FormHeaderElement(),
            new FormHeaderElement(),
            new FormHeaderElement('Contracting exec:', form.CE ? this.dpOptions.UserList.find((user) => user.id == form.CE)?.value : (docStatus.find(
              (statusName) => {
                return statusName.DocumentStatusCatId ==
                  form.documentStatusId?.toString()
              }
            )?.['Name'].trim() == 'New' && docType.find(
              (statusName) =>
                statusName.DocumentStatusTypeId ==
                form.documentSubStatusId?.toString()
            )?.['Name'].trim() == 'New') ? '-' : 'To be assigned')
          ])
        }
       
        await this.checkIfRfs(this.form)
      });

      this.rfsService.assignmentList$.pipe(takeUntil(this.destroy$)).subscribe(async (assignmentList: AssignmentList) => {
        const data = assignmentList.data
        if (data && data.MPDocumentNumber === this.form.documentNo && data.requestorUsername === this.loggedInUsername) {
          let oldShouldShowPEView = this.shouldShowPEView;

          if (data.dagId) {
            this.shouldShowPEView = true
              this.peResponseObj = data
          } else {
            this.shouldShowPEView = false
            this.peResponseObj = undefined
          }

          if (oldShouldShowPEView !== this.shouldShowPEView) {
            await this.onFormChangeHandleLock();
          }
        }
      })
  }

  async onFormChangeHandleLock() {
    const form = this.form;

    if (!this.firstRequestToAcquireLockMade && this.form.documentNo && this.shouldShowPEView && form.documentStatusId == DocumentMainStatus.Pending_PE_Sourcing && form.documentSubStatusId == DocumentSubStatus.Pending_Sourcing) {
      let value: DocumentLock = await lastValueFrom(this.backEndService.getDocumentLock(this.form.documentNo, this.loggedInUsername))
      let isLockObtained = value.LockObtained
      this.rfsLocked = !isLockObtained
      this.firstRequestToAcquireLockMade = true

      if (isLockObtained && this.setIntervalToCheckRfsLock == null){
        this.setIntervalToCheckRfsLock = setInterval(() => {
          this.refreshRfsLock(this.form.documentNo!, this.loggedInUsername)
        }, environment.rfsRefreshLockIntervalInMinutes * 60 * 1000)
      }
      if (isLockObtained && this.setIntervalForExtensionPrompt == null){
        this.setIntervalForExtensionPrompt = setInterval(() => {
          this.showExtensionPrompt()
        }, environment.rfsSessionPromptIntervalInMinutes * 60 * 1000)
      }
      if (!isLockObtained && value.Username && !isEqual(value.Username, this.loggedInUser.userName)) {
        this.infoDialogRef = this.dialog.open(RfsInfoDialogComponent, {
          // height: '280px',
          // width: '500px',
          data: {
            title: "Editing restricted",
            content: `${this.returnFullNameOfUser(value.Username)} is currently editing this document. <br/> <br/> You will not be able to make changes until the current editor exits or his/her session expires.` as any as InnerHTML
          }
        })
      }    
    }
  }

  getPurchaseTypeString() {
    switch (this.purchaseType) {
      case 'rfq':
        this.purchaseTypeString = 'Request For Quotation';
        break;
      case 'tender':
        this.purchaseTypeString = 'Tender';
        break;
      case 'corporatecard':
        this.purchaseTypeString = 'Corporate Credit Card';
        break;
      case 'dc':
        this.purchaseTypeString = 'Direct Contracting';
        break;
      case 'permissiblecoveringpurchaseorder':
        this.purchaseTypeString = 'Permissible Covering Purchase Order';
        break;
    }
  }
  returnFullNameOfUser(username: string) {
    return this.dpOptions.UserList.find(x => x.id == username)?.value ?? username
  }

  async shouldShowRoDialog() {
    let isRecalled: boolean = false;
    let obj = {
      MPDocumentNumber: this.mpNumber,
      actioner: this.loggedInUsername,
      dagId: this.dagId
    };
    await lastValueFrom(this.backEndService.checkRFSReady(obj)).catch((e)=>{
      isRecalled = e.error.Recalled;
    });
    if (!isRecalled) {
      this.drawer.toggle();
    }
    else {
      this.showRoDialog();
    }
  }

  showExtensionPrompt() {
    const currentTime = new Date().getTime()
    let userData: boolean | undefined = undefined
    if (this.extensionDialogRef == null) {
      this.extensionDialogRef = this.dialog.open(RfsExtendLockDialogComponent, {
        height: '230px',
        width: '500px',
        hasBackdrop: true,
      })
      this.extensionDialogRef.afterClosed().subscribe(async (data) => {
        console.log(data)
        userData = data
        this.extensionDialogRef = null
        if (new Date().getTime() - currentTime < environment.rfsSessionExtensionWindowInMinutes * 60 * 1000 && data === false) {
          this.clearIntervals()
          this.rfsLocked = true
          await this.saveDetailsBeforeExpiringSession()
          this.showExpiredSessionDialog()
        }
      })
    }
    setTimeout(async () => {
      if (userData === undefined) {
        this.clearIntervals()
        this.rfsLocked = true
        await this.saveDetailsBeforeExpiringSession()
        this.showExpiredSessionDialog()
        if (this.extensionDialogRef != null) {
          this.extensionDialogRef.close()
          this.extensionDialogRef = null;
        }
      }
    }, environment.rfsSessionExtensionWindowInMinutes * 60 * 1000)
  }
  async saveDetailsBeforeExpiringSession() {
    await this.rfsService.onPostRFSSave();
    // this.showLoader = true
    // try {
    //   await this.validateMyPurchase()
    //   let dataToSend: SaveMyPurchase = this.formatDataForSave();
    //   let response: any = await lastValueFrom(
    //     this.backEndService.saveMyPurchase(dataToSend)
    //   );
    //   await this.saveAttachments(response);
    //   await this.saveVendorTagging()
    // }
    // catch (err) {
    //   console.error(err)
    // }
    // finally {
    //   this.showLoader = false
    // }
  }

  async showRoDialog() {
    this.RODialogRef = this.dialog.open(RfsInfoDialogComponent, {
      data: {
        title: 'MP Document recalled by RO',
        content: `RO has recalled this MP document, system will terminate your session. Your changes will not be saved.
                  No further action is required from PEs until RO re-submits.` as any as InnerHTML
      },
    })
    await this.loadData();
  }
  
  showExpiredSessionDialog() {
    if (this.infoDialogRef?.getState() === MatDialogState.OPEN) {
      this.infoDialogRef.close()
      this.infoDialogRef = null;
    }
    this.infoDialogRef = this.dialog.open(RfsInfoDialogComponent, {
      // height: '210px',
      // width: '500px',
      hasBackdrop: true,
      data: {
        title: "Session expired",
        content: "As your session has expired, your editing rights have been locked, and all changes have been automatically saved."
      }
    })
  }
  clearIntervals() {
    if (this.setIntervalToCheckRfsLock != null) clearInterval(this.setIntervalToCheckRfsLock)
    if (this.setIntervalForExtensionPrompt != null) clearInterval(this.setIntervalForExtensionPrompt)
  }

  refreshRfsLock(formDocNo: string, username: string) {
    lastValueFrom(this.backEndService.getDocumentLock(formDocNo, username)).then((data: DocumentLock) => {
      this.rfsLocked = !data.LockObtained
      console.log("refresh rfs lock", this.rfsLocked, data)
    });
  }

  checkIfVendorsUpdated(oldForm: MyPurchaseForm, newForm: MyPurchaseForm) {
    if (!oldForm || !newForm || !Object.hasOwn(oldForm, 'documentNo') || !Object.hasOwn(newForm, 'documentNo')) return
    if (isEqual(oldForm.documentNo, newForm.documentNo) && !isEqual(oldForm.VendorsToSource, newForm.VendorsToSource))
      this.wasVendorsUpdated = true
  }
  async checkIfRfs(form: MyPurchaseForm) {
    if (doesNotMeetRfsCriteria(form)) return
    const resp: RfsSourcingResponse = await lastValueFrom(this.backEndService.getSourcingOutcomes(form.documentNo!))
    if (resp.deactivatedItemList) {
      let results = this.transformer.parseItemListData(resp.deactivatedItemList, this.dpOptions).map(x => ({
        ...x,
        isDeleted: true
      }))
      let deactivatedItems = results
      const itemIdMap = this.getItemIdsMap(deactivatedItems, form.ItemList)
      this.store.dispatch(updateRfsOutcomes({ rfsOutcomes: resp, deletedItemIdMappings: itemIdMap }))
    }
    else this.store.dispatch((updateRfsOutcomes({ rfsOutcomes: resp, deletedItemIdMappings: new Map<number, { itemId: number, displayItemNumber: number }>() })))
  }
  getItemIdsMap(deactivatedItemsOriginal: IItemToRequest[], formItemList: IItemToRequest[]) {
    let deactivatedItems = deactivatedItemsOriginal.sort((a, b) => a.AddItems.PurchaseItemId! - b.AddItems.PurchaseItemId!)
    let itemIdMappings: Map<number, { itemId: number, displayItemNumber: number }> = new Map<number, { itemId: number, displayItemNumber: number }>()
    const maxDisplayItemNumber = Math.max(0, ...formItemList.map(item => item?.AddItems?.displayItemNumber ?? 0))
    for (let i = 0; i < deactivatedItems.length; i++) {
      if (deactivatedItems[i].AddItems.PurchaseItemId)
        itemIdMappings.set(deactivatedItems[i].AddItems.PurchaseItemId!, { itemId: formItemList.length + i + 1, displayItemNumber: deactivatedItems[i].AddItems.displayItemNumber })
    }
    return itemIdMappings
  }
  async validateBudgetAllocationAmounts() {
    let convertedItemPriceList = await this.returnItemListInSGD(this.form.ItemList)
    let totalItemPrice: number = this.calculateTotalAmount(convertedItemPriceList)
    let allBudgetAllocationForms = this.form.ItemList.flatMap(x => x.isDeleted ? [] : x.BudgetAllocation.filter(x => !x.isDeleted))
    let totalBudgetAllocationCost: number = getTotalBudgetCost(allBudgetAllocationForms, convertedItemPriceList)
    console.log('validateBudgetAllocations', totalBudgetAllocationCost, totalItemPrice)
    if (!isNaN(totalItemPrice) && !isNaN(totalBudgetAllocationCost)) {
      totalBudgetAllocationCost = round(totalBudgetAllocationCost, 2)
      totalItemPrice = round(totalItemPrice, 2)
      if (totalItemPrice > totalBudgetAllocationCost)
        this.validatedDraftMsgs.push({
          message: 'Please ensure that your budget allocation is fully split as per the estimated amount of your item', category: ValidationErrorCategory.ItemVendor
        })
    }
  }
  async validateBudgetAllocations(formItems: IItemToRequest[]) {
    let items = formItems.filter(x => !x.isDeleted);
    let itemNeedsReview = new Set<number>();
  
    items.forEach(item => {
      item.BudgetAllocation.forEach(alloc => {
        if (alloc.isDeleted) return;
  
        const displayNumber = item.AddItems.displayItemNumber;
  
        const setError = (field: ItemFieldName) => {
          this.itemErrorService.setItemErrorDetails(displayNumber, ItemTabName.Budget, [field]);
          itemNeedsReview.add(displayNumber);
        };
  
        if (!alloc.BudgetType.id || alloc.BudgetType.id.length === 0) {
          setError(ItemFieldName.BudgetType);
        } else {
          switch (alloc.BudgetType.value.trim().toLowerCase()) {
            case 'operating':
              if (missingCostCenterFields(alloc)) setError(ItemFieldName.CostCentre);
              if (missingGLFields(alloc)) setError(ItemFieldName.GLAccount);
              if (missingBudgetExpenditureUsage(alloc)) setError(ItemFieldName.BudgetExpenditure);
              if (missingBudgetFrequencyUsage(alloc)) setError(ItemFieldName.BudgetFrequency);
              break;
            case 'project':
              if (missingProjectBudget(alloc)) setError(ItemFieldName.ProjectBudget);
              if (missingProjectCode(alloc)) setError(ItemFieldName.ProjectCode);
              if (missingGLFields(alloc)) setError(ItemFieldName.GLAccount);
              break;
            case 'capital':
              if (missingFundCenter(alloc)) setError(ItemFieldName.FundCentre);
              if (missingGLFields(alloc)) setError(ItemFieldName.GLAccount);
              if (missingBudgetExpenditureUsage(alloc)) setError(ItemFieldName.BudgetExpenditure);
              break;
            case 'capital auc':
              if (missingProjectBudget(alloc)) setError(ItemFieldName.ProjectBudget);
              if (missingGLFields(alloc)) setError(ItemFieldName.GLAccount);
              if (missingBudgetExpenditureUsage(alloc)) setError(ItemFieldName.BudgetExpenditure);
              break;
            default:
              break;
          }
  
          if (
            alloc.BudgetExpenditureUsage &&
            !alloc.BudgetExpenditureUsage.id &&
            [2, 3].includes(this.form.documentStatusId) &&
            alloc.BudgetType.value.trim().toLowerCase() !== 'project'
          ) {
            setError(ItemFieldName.UnbudgetedSelected);
          }
        }
      });
    });
  
    if (itemNeedsReview.size == 0) {
      await this.validateBudgetAllocationAmounts();
    } 
  }
  async returnItemListInSGD(itemList: IItemToRequest[]) {
    let newItemList = structuredClone(itemList)
    newItemList = newItemList.filter(x => !x.isDeleted)
    for (const item of newItemList) {
      item.ItemPrice.UnitPrice = await this.currencyService.convertAsyncCurrencyToSGD(item.ItemPrice.UnitPrice, item.ItemPrice.Currency.value) ?? 0
    }
    return newItemList
  }
  calculateTotalItemPrice(itemList: IItemToRequest[]) {
    let estimatedTotal: number = 0.0;
    for (const item of itemList) {
      let totalAmount = (item.ItemPrice.Quantity * item.ItemPrice.UnitPrice) / item.ItemPrice.UnitsPerQuantity;
      estimatedTotal += totalAmount;
    }
  }
  async convertCurrencyToSGD(amount: number, currCode: string) {
    if (currCode == 'SGD') return amount
    let currEx = this.currencyExchangeRates.find(x => x.FromCurrency == currCode)
    if (!currEx) {
      const resp: CurrencyExchange = await lastValueFrom(this.backEndService.getCurrencyExchange(currCode));
      currEx = resp
      this.store.dispatch(addCurrencyExchange({ currency: resp }))
    }
    return (amount * (currEx!.Rate / currEx.RatioForTheFromCurrencyUnits))
  }
  async getSystemConfiguration(code: string) {
    // const resp: SystemConfiguration | null = this.systemConfigurationService.getSystemConfiguration(
    //   SystemConfigurationCode.POCapitalBuyItemUnitPriceThreshold
    // );
    // return resp?.Value;
    const resp: SystemConfiguration = await lastValueFrom(this.backEndService.getSystemConfiguration('PO_capitalbuyitemunitpricethreshold'))
    return resp.Value;
  }
  async closeSideNav(result: any) {
    console.log('closeSideNav', result)
    this.openPeAssignmentList = false;
    if (result.wasTransferCalled) await this.loadData()
  }

  openCopyDialog() {
    this.dialogRefCopy = this.dialog.open(DialogComponent, {
      // height: '230px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Create a copy?',
        contentMsg: 'Do you wish to create a copy of the current document?',
        btnNameOne: 'Copy',
        btnNameTwo: 'Cancel',
        click: () => {
          this.copyDraft();
          this.dialogRefCopy.close();
        },
        clickTwo: () => {
          this.dialogRefCopy.close();
        }
      },
    });
  }

  openDeleteDialog() {
    this.dialogRefDelete = this.dialog.open(DialogComponent, {
      // height: '230px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Delete MP Document',
        contentMsg: 'This will delete the MP document permanently. You cannot undo this action.',
        btnNameOne: 'Delete',
        btnNameTwo: 'Cancel',
        btnTwoColor: 'warn',
        click: () => {
          this.deleteDraft();
          this.dialogRefDelete.close();
        },
        clickTwo: () => {
          this.dialogRefDelete.close();
        }
      },
    });
  }
  
  async deleteDraft(): Promise<void> {
    let mpDocumentNumber = this.form.documentNo;
    let MPReferenceDocument = this.form.parentDocumentNo;
    let RO = this.form.generalForm.RO.id;
    let creator = this.form.createdBy;
    if (RO === this.loggedInUsername || creator === this.loggedInUsername) {
      this.setLoader("deleteDraft");
      if (mpDocumentNumber && !MPReferenceDocument) {
        let response: any = await lastValueFrom(
          this.backEndService.deleteDraft(mpDocumentNumber)
        );
        this.releaseLoader("deleteDraft");
        this.openSnackBar("MP Document deleted successfully");
        this.router
          .navigateByUrl('/redirect', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/land']);
          });
      }
    }
  }

  async copyDraft(): Promise<void> {
    // this.showLoader = true;
    this.setLoader("copyDraft");
    // let errors: string[] = this.validateSaveDraft();
    console.log("this.form copyDraft", this.form);
    let copyForm = { ...this.form };
    // let copyForm = structuredClone(this.form);
    copyForm.Type = "1";
    copyForm.CE = "",
      copyForm.Env = "OA";
    copyForm.documentNo = null;
    copyForm.WOCId = null;
    copyForm.DOTPId = null;
    copyForm.TenderStartDate = null;
    copyForm.TenderStartTime = null;
    copyForm.TenderEndDate = null;
    copyForm.TenderEndTime = null;
    copyForm.parentDocumentNo = null;
    let i = 1;
    let itemNumber = 1;
    let modifiedItemJson = copyForm.ItemList.filter(item => !item.isDeleted && !item.Strikethrough).map((item) => {
      let result = {
        ...item,
        AddItems: {
          ...item.AddItems,
          PurchaseItemId: null,
          SourcingStatusId: null,
          ReferenceId: null,
          TaggedVendors: null,
          itemId: i,
          displayItemNumber: item.isDeleted ? 0 : itemNumber++, // use, then increment
        },

        AddOnFeature: item.AddOnFeature ? item.AddOnFeature.map((addOn) => ({
          ...addOn,
          // MPDocumentNumber: null,
          PurchaseItemId: null,
          ItemAddOnId: null,
          itemId: i,
          displayItemNumber: i,
        })) : [],
        BudgetAllocation: item.BudgetAllocation ? item.BudgetAllocation.map((budget) => ({
          ...budget,
          BudgetItemId: null,
          displayPurchaseItemNumber: i,
        })) : [],
      }
      i += 1
      return result
    });
    let modifiedVendorJson = copyForm.VendorsToSource.filter(vendor => !vendor.isDeleted && !vendor.Strikethrough).map((vendor) => ({
      ...vendor,
      MPVendorDetailsId: null,
      isDeleted: false
    }));
    let modifiedoptionToPurchaseJson = copyForm.optionToPurchase ? copyForm.optionToPurchase.map((option) => ({
      ...option,
      ItemAddOnId: null,
      isDeleted: false,
      MPDocumentNumber: null
    })) : []


    // let copyGeneralForm = structuredClone(this.form.generalForm);
    let copyGeneralForm = { ...this.form.generalForm };
    let modifiedExcoBoardDocumentArray = copyGeneralForm.excoBoardDocumentArray
      ? copyGeneralForm.excoBoardDocumentArray.map((excoDoc) => ({
        ...excoDoc,
        EXCOApprovalID: null,
      }))
      : [];
    console.log("copyForm 222", modifiedExcoBoardDocumentArray)
    // copyGeneralForm.excoBoardDocumentArray = modifiedExcoBoardDocumentArray;
    // copyForm.generalForm.excoBoardDocumentArray = modifiedExcoBoardDocumentArray;
    copyGeneralForm.excoBoardDocumentArray = modifiedExcoBoardDocumentArray;
    copyForm.generalForm = copyGeneralForm; // Assign the modified generalForm back to copyForm


    copyForm.ItemList = modifiedItemJson;
    copyForm.VendorsToSource = modifiedVendorJson;
    copyForm.optionToPurchase = modifiedoptionToPurchaseJson;
    copyForm.ExchangeRateLock = false;
    copyForm.isRFS = false;
    console.log("copyForm == ", copyForm)
    this.store.dispatch(updateWholeForm({ form: copyForm }));
    this.store.dispatch(clearDeletedItemVendorStore())
    this.store.dispatch(clearAttachmentStore())
    this.store.dispatch(clearTaggingStore())
    // this.store.dispatch(updateItemForm({ form: modifiedItemJson }));
    this.currentWorkflowService.updateWorkflow(null); 
    this.currentWorkflowService.setisWocApproved(false);         
    this.router
      .navigateByUrl('/redirect', { skipLocationChange: true })
      .then(() => {
        this.router.navigate(['/purchase/', this.purchaseType, 'draft']);
      });
    
      // this.showLoader = false;
      this.releaseLoader("copyDraft");
  }

  async loadData() {
    if (this.mpNumber != 'draft') {
      try {
        if (this.edited) {
          this.selectedIndex = 1;
          if (this.form.documentNo == '') {
            this.backtoSameRFQRedirect();
          }
          // which loader are we excepting this to disabled?
          // this.showLoader = false;
          this.clearLoader("loadData 1");
          return;
        }
        if (this.tagged) {
          this.selectedIndex = 2;
          if (this.form.documentNo == '') {
            this.backtoSameRFQRedirect();
          }
          // which loader are we excepting this to disabled?
          // this.showLoader = false;
          this.clearLoader("loadData 2");
          return;
        }

        // getting data from server and updating the header
        let draftForm: SaveMyPurchase = await lastValueFrom(
          this.backEndService.getDraft(this.mpNumber)
        );
        let transFormedDraftForm: MyPurchaseForm = this.formTransformer.transformInverse(
          draftForm,
          this.dpOptions
        );
        this.store.dispatch(updateWholeForm({ form: transFormedDraftForm }));

        // Tagging for item-vendor
        if (transFormedDraftForm.documentNo && (transFormedDraftForm.TaggedGroups || transFormedDraftForm.documentStatusId === 15)) {
          this.tagItemVendorService.setTaggedGroupsIfDocNumberChanged(transFormedDraftForm.documentNo, transFormedDraftForm.TaggedGroups ?? [])
        }
        // which loader are we excepting this to disabled?
        // this.showLoader = false;
        this.clearLoader("loadData 3");
      } catch (e) {
        console.log('error retrieving data', e);
      }
    } else {
      if (this.edited) {
        this.selectedIndex = 1;
        // which loader are we excepting this to disabled?
        // this.showLoader = false;
        this.clearLoader("loadData 4");
      }
      if (this.tagged) {
        this.selectedIndex = 2;
      }

      if(!this.edited && !this.tagged) {
        this.selectedIndex = 0;
      }

      // update purchase type based on route for new forms;
      if (this.router.url.includes('rfq')) {
        this.store.dispatch(updateFormType({ typeId: 1 }));
      } else if (this.router.url.includes('tender')) {
        this.store.dispatch(updateFormType({ typeId: 6 }));
      } else if (this.router.url.includes('corporatecard')) {
        this.store.dispatch(updateFormType({ typeId: 3 }));
      } else if (this.router.url.includes('dc')) {
        this.store.dispatch(updateFormType({ typeId: 5 }));
      } else if (this.router.url.includes('permissiblecoveringpurchaseorder')) {
        this.store.dispatch(updateFormType({ typeId: 9 }));
      }
      let formStatus: FormStatus = {
        documentStatusId: 2,
        documentSubStatusId: 1,
        createdBy:
          this.dpOptions.UserList.find(
            (user) => user.id == this.loggedInUser.userName
          )?.id ?? '',
        CreatedOn: new Date(),
      };
      this.store.dispatch(updateFormStatus({ formStatus: formStatus }));
      // which loader are we excepting this to disabled?
      // this.showLoader = false;
      this.clearLoader("loadData 5");
    }
  }

  async ngOnInit(): Promise<void> {
    this.setLoader("init");
    const previousPageName = sessionStorage.getItem('fromPage');
    if (previousPageName) {
      this.breadCrumbFlow = [previousPageName];
    } 
    if (!this.dpOptions.UserList.length) {
      this.dpOptions = await firstValueFrom(
        this.store.select('dp').pipe(skip(1))
      );
    }
    this.currentWorkflowService.updateWorkflow(null);
    await this.loadData();
    if(this.form.documentStatusId === 2)  {
      this.releaseLoader("init");
      return;
    };
    // if (this.form.documentStatusId === DocumentMainStatus.Draft || this.form.documentStatusId === DocumentMainStatus.Rejected) {
    //   this.validateSaveDraft(false);
    //   this.validateMyPurchase(false);
    // }
    const response: PEAssignmentListResponse = await lastValueFrom(
    this.backEndService.getAssignmentList(this.mpNumber, this.loggedInUsername));
    this.dagId = response.dagId ?? '';
    this.releaseLoader("init");
  }

  currentTab(event: MatTabChangeEvent) {
    let currentIndex = event.index;
    sessionStorage.setItem('currentTab', currentIndex.toString());
  }

  async initValidation(event: any): Promise<void> {
    // if (this.form.documentStatusId === DocumentMainStatus.Draft || this.form.documentStatusId === DocumentMainStatus.Rejected) {
    //   this.validateSaveDraft(false);
    //   this.validateMyPurchase(false);
    // }
  }

  checkAndGenerateRFSOutcomes(resp: RfsSourcingResponse, deletedItemMappings: Map<number, { itemId: number, displayItemNumber: number }>) {
    if (this.rfsOutcomeResults) return
    this.rfsOutcomeResults = resp
    let msg = '<b>Request for Sourcing Outcomes</b><br>'
    if (resp.outcome == RfsOutcome.partial) {
      if (resp.wocItems && resp.wocItems.length > 0)
        msg = `Items with only one vendor available have been split into different child documents as displayed in the “Reference” tab.<br>`
      if ((resp.smlItems && resp.smlItems.length > 0) || (resp.emptyVendors && resp.emptyVendors.length > 0) || (resp.priceAgreementItems && resp.priceAgreementItems.length > 0))
        msg += `The following items and/or vendors are deleted from current document due to the following reasons:<br>`
      if (resp.smlItems && resp.smlItems.length > 0) {
        let convertedItemIds = this.returnFrontEndItemIds(resp.smlItems, deletedItemMappings)
        msg += `Item no: (${convertedItemIds.join('), (')}). Reason: <b>Draw from SML</b><br>`
      }
      if (resp.priceAgreementItems && resp.priceAgreementItems.length > 0) {
        let convertedItemIds = this.returnFrontEndItemIds(resp.priceAgreementItems, deletedItemMappings)
        msg += `Item no: (${convertedItemIds.join('), (')}). Reason: <b>Price agreement available</b><br>`
      }
      if (resp.emptyVendors && resp.emptyVendors.length > 0) {
        msg += `Vendors: ${resp.emptyVendors.join(', ')}. Reason: <b>No items tagged</b>`
      }
      this.bannerService.addMessage({ type: BannerType.warning, content: msg }, this.form.documentNo!)
    }
    else if (resp.outcome == RfsOutcome.unsuccessful) {
      msg = 'We regret to inform that none of the items you requested for sourcing assistance were successful. In your new document, do consider adding more alternative items to improve your chances.'
      this.bannerService.addMessage({ type: BannerType.error, content: msg }, this.form.documentNo!)
    }
  }

  returnFrontEndItemIds(itemIds: string[], itemIdMap: Map<number, { itemId: number, displayItemNumber: number }>) {
    let convertedItemIds: number[] = itemIds.map(x => Number(x)).filter(x => !Number.isNaN(x)).map(x => itemIdMap.get(x)?.displayItemNumber || x)
    return convertedItemIds
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    if (this.setIntervalToCheckRfsLock != null) clearInterval(this.setIntervalToCheckRfsLock)
    if (this.setIntervalForExtensionPrompt != null) clearInterval(this.setIntervalForExtensionPrompt)
  }

  async saveDraft(optionalSuccessMessage?: string, fromAction?: string): Promise<void> {
    this.setLoader("saveDraft");
    let errors: ValidationErrorMessage[] = this.validateSaveDraft(true);
    if (errors.length == 0) {
      this.bannerService.clearValidationMessages()
      let dataToSend: SaveMyPurchase = await this.formatDataForSave();
      console.log(dataToSend, 'form to send');
      try {
        let response: any = await lastValueFrom(
          this.backEndService.saveMyPurchase(dataToSend)
        );
        console.log(response);
        // upload attachments
        await this.saveAttachments(response);
        let successMessage = optionalSuccessMessage || 'Document successfully saved!'
        if (fromAction !== 'validate') this.openSnackBar(successMessage);
        
      this.setLoader("artificialsaveloader");
        setTimeout(() => {
          this.mpNumber = response.MPDocumentNumber;
          this.mpNumberSubject.next(this.mpNumber); // Update mpNumber
          if (this.form.generalForm.RO.id === this.loggedInUsername || this.form.createdBy == this.loggedInUsername) {
            if (fromAction === 'validate') this.backtoSameRFQRedirect();
            else this.backtoSameRFQRedirect(true);
          } else {
            window.location.reload();
          }
          this.releaseLoader("artificialsaveloader");
        }, 1500);
      } catch (e: any) {
        console.log(e.message);
        this.showLoader = false;
        this.bannerService.addMessage({ content: e.message as string, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7));
        if (e.status === 500) {
          this.openSnackBar(
            'Document unable to save. Please contact administrators if the problem persists.',
            "error"
          );
        } else {
          const currentUrl = this.router.url;
          sessionStorage.setItem('lastUrl', currentUrl);
          this.router.navigateByUrl('/wentWrong');
        }
      }
    } else {
      let finalHtml = this.returnFinalMessageInHtml(errors)
      this.bannerService.addMessage({ content: finalHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
    }
    this.releaseLoader("saveDraft");
    // this.showLoader = false;
  }

  async generateRFQ(): Promise<void> {
    // this.showLoader = true;
    this.setLoader("generateRFQ");
    let errors: ValidationErrorMessage[] = this.validateSaveDraft(true);
    if (errors.length == 0) {
      this.bannerService.clearValidationMessages()
      let form: SaveMyPurchase = await this.formatDataForSave();
      let dataToSend = {
        MPDocumentNumber: form.MPDocumentNumber,
        RFQDeadline: form.RFQDeadline,
        actioner: this.loggedInUser.userName,
        vendorsList: form.vendorsList
      }
      try {
        let response: any = await lastValueFrom(
          this.backEndService.generateRFQ(dataToSend)
        );
        console.log(response);
        // upload attachments
        await this.saveAttachments(response);
        this.openSnackBar('Document succesfully saved!');
        setTimeout(() => {
          this.mpNumber = response.MPDocumentNumber;
          this.backtoSameRFQRedirect();
        }, 1500);
      } catch (e) {
        console.log(e);
        this.openSnackBar(
          'Document unable to generate RFQ. Please contact administrators if the problem persists.',
          "error"
        );
        this.releaseLoader("generateRFQ");
        // this.showLoader = false;
        this.bannerService.addMessage({ content: e as string, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
        // this.router.navigateByUrl('/connectionLost');
      }
    } else {
      let finalHtml = this.returnFinalMessageInHtml(errors)
      this.bannerService.addMessage({ content: finalHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
    }
    this.releaseLoader("generateRFQ");
    // this.showLoader = false;
  }

  validateItemDescription(itemlist: IItemToRequest[]) {
    if (itemlist.length == 0) return
    // let doAllItemsHaveADescription: boolean = true
    for (const item of itemlist) {
      if (!item.AddItems.ItemDescription || item.AddItems.ItemDescription.length == 0) {
        // doAllItemsHaveADescription = false
        this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.ItemDesc]);
      }
    }
    // if (!doAllItemsHaveADescription) {
    //   this.validatedDraftMsgs.push({
    //     message: 'Please fill up the item description for all items.', category: ValidationErrorCategory.ItemVendor
    //   });
    // }
  }
  validateProjectBudgets() {
    let noProjectCode: boolean = false;
    let noProjectBudget: boolean = false;
    for (const item of this.form.ItemList) {
      if (!item.isDeleted) {
        for (const budget of item.BudgetAllocation) {
          if (budget.BudgetType.id == 'Project' && !budget.isDeleted) {
            if (!budget.ProjectCode || (budget.ProjectCode && budget.ProjectCode.id == ''))
              noProjectCode = true
            if (!budget.ProjectBudget || (budget.ProjectBudget && budget.ProjectBudget.id == ''))
              noProjectBudget = true
          }
        }
      }
      if (noProjectCode)
        this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.ProjectCode]);
      // this.validatedDraftMsgs.push({
      //   message: 'Please fill up the project code for your Project Budget allocation.', category: ValidationErrorCategory.ItemVendor
      // })
      if (noProjectBudget)
        this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.ProjectBudget]);
      // this.validatedDraftMsgs.push({
      //   message: 'Please fill up the project budget for your Project Budget allocation.', category: ValidationErrorCategory.ItemVendor
      // });
    }
  }
  async validateMyPurchase(
    showSnackbar?: boolean
    // , disableLoader?: boolean
  ) {
    this.validatedDraftMsgs = [];
    this.setLoader("validateMyPurchase");
    // if(!disableLoader) {
    //   this.showLoader = true;
    // }
    this.itemErrorService.clearItemErrorDetails();
    this.validatePermissibleReasons();
    await this.validateExcoBoardDocumentReferences();
    this.validateItemDescription(this.form.ItemList)
    await this.validateBudgetAllocations(this.form.ItemList)
    if (this.form.generalForm.purpose == '') {
      this.validatedDraftMsgs.push({
        message: 'Please fill up your purpose of purchase.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.form.generalForm.internal.value == '') {
      this.validatedDraftMsgs.push({
        message: 'Please select an internal security classification level.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.form.generalForm.external.value == '') {
      this.validatedDraftMsgs.push({
        message: 'Please select an external security classification level.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.form.generalForm.typeOfRequisition?.id == "PR9999" && !this.form.generalForm.requisitionOthers) {
      this.validatedDraftMsgs.push({
        message: 'Please specify your other requisition type.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.purchaseType === 'rfq' && this.form.generalForm.reasonForNotUsingRFQ.value === '') {
      this.validatedDraftMsgs.push({
        message: 'Please select a pre-approved reason why system RFQ is not required.', category: ValidationErrorCategory.BasicInformation
      })
    }
    //validate item description
    if (this.form.ItemList.length < 1) {
      this.validatedDraftMsgs.push({
        message: 'Please add at least one item to request.', category: ValidationErrorCategory.ItemVendor
      });
    } else {
      let hasCheckedGEWCAVendors = false;
      let blockedAirTicketItemNumbers = [];
      for (const item of this.form.ItemList.filter(x => !x.isDeleted && !x.Strikethrough)) {
        
        // SML Deviation
        if(item.AddItems.IsSML && !item.AddItems.SMLReasonId) {
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.SMLDeviation]);
        }

        // let invalidDurationFound = false;
        if (item.AddOnFeature && item.AddOnFeature.length > 0) {
          for (let addOnFeature of item.AddOnFeature) {
            if (addOnFeature.Strikethrough || addOnFeature.isDeleted) continue
            else if (
              (addOnFeature.DurationYears === 0 && addOnFeature.DurationMonths === 0) ||
              (addOnFeature.DurationMonths && addOnFeature.DurationMonths >= 12)
            ) {
              // invalidDurationFound = true;
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.AddOn, [ItemFieldName.Duration]);
              break;
            }
          }
        }
        // if (invalidDurationFound) {
        // this.validatedDraftMsgs.push({
        //   message:
        //     'The duration provided is invalid. If the Duration (of) Years is 0, then the Duration (of) Months should not be 0, and if there is a Duration (of) Months, it should not exceed 12 months.', category: ValidationErrorCategory.ItemVendor
        // }
        // );
        //  }

        if (item.AddItems.MaterialGroupId) {
          if (
            (item.AddItems.MaterialGroupId.Code == '' &&
              item.AddItems.MaterialGroupId.Name == '') ||
            (item.AddItems.MaterialGroupId.Code == null &&
              item.AddItems.MaterialGroupId.Name == null)
          ) {
            // this.validatedDraftMsgs.push({
            //   message: 'An item does not have a material group.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.MaterialGroup]);
          }
        } else {
          // this.validatedDraftMsgs.push({
          //   message: 'An item does not have a material group.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.MaterialGroup]);
        }

        if (item.AddItems.MaterialGroupId) {
          if (
            (item.AddItems.MaterialSubGroupId?.Code == '' &&
              item.AddItems.MaterialSubGroupId?.Name == '') ||
            (item.AddItems.MaterialSubGroupId?.Code == null &&
              item.AddItems.MaterialSubGroupId?.Name == null)
          ) {
            // this.validatedDraftMsgs.push({
            //   message: 'An item does not have a material sub group.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.MaterialSubGroup]);
          } else {
            let matSubGpValidations = item.AddItems.MaterialSubGroupId;
            let matSubMsg =
              'The material subgroup ' + item.AddItems.MaterialSubGroupId.Name;

            if (matSubGpValidations.IsBrandRequired) {
              if (
                !item.AddItems.BrandOEMName ||
                item.AddItems.BrandOEMName.value == null ||
                item.AddItems.BrandOEMName.value == ''
              ) {
                // this.validatedDraftMsgs.push({
                //   message: `${matSubMsg} requires a Brand/OEM.`, category: ValidationErrorCategory.ItemVendor
                // });
                this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.Brand]);
              }
            }
            // if (matSubGpValidations.IsCOTSCustRequired) {
            //   if (item.AddItems.isCOTS == null) {
            //     this.validatedDraftMsgs.push(matSubMsg + ' requires a COTS.');
            //   }
            // }
            if (matSubGpValidations.IsCriticalityRequired) {
              if (
                !item.AddItems.CriticalityId ||
                item.AddItems.CriticalityId.value == '' ||
                item.AddItems.CriticalityId.value == null
              ) {
                // this.validatedDraftMsgs.push({
                //   message:
                //     `${matSubMsg} requires a Criticality Code.`, category: ValidationErrorCategory.ItemVendor
                // }
                // );
                this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.Critical]);
              }
            }
            if (matSubGpValidations.IsIPCClassRequired) {
              if (
                !item.AddItems.WorkmanshipId ||
                item.AddItems.WorkmanshipId.value == '' ||
                item.AddItems.WorkmanshipId.value == null
              ) {
                // this.validatedDraftMsgs.push({
                //   message:
                //     `${matSubMsg} requires a Worksmanship.`, category: ValidationErrorCategory.ItemVendor
                // });
                this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.Workmanship]);
              }
            }
            if (matSubGpValidations.IsPartNumberRequired) {
              // this.validatedDraftMsgs.push({
              //   message:
              //     `${matSubMsg} requires a part/model no.`, category: ValidationErrorCategory.ItemVendor
              // });
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.PartModelNum]);
            }

            // Check for blocked air ticket material sub group
            if (matSubGpValidations.Code === environment.airTicketMaterialGroupCode) {
              blockedAirTicketItemNumbers.push(item?.AddItems?.displayItemNumber ?? '');
            }

            // Check for GEWCA
            // Skip if check was performed before for another item
            if (matSubGpValidations.IsGEWCA && !hasCheckedGEWCAVendors) {
              await this.validationService.validateGEWCA(this.validatedDraftMsgs, this.form.documentNo!, this.form.VendorsToSource, ValidationErrorCategory.ItemVendor)
              hasCheckedGEWCAVendors = true;
            }
          }
        } else {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a material sub group.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.MaterialSubGroup]);
        }

        if (
          item.AddItems.PlannedDeliveryDate == null ||
          !item.AddItems.PlannedDeliveryDate
        ) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a planned delivery date.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.PlannedDeliveryDate]);
        } else if (this.form.documentSubStatusId && [1, 11, 12, 55].includes(this.form.documentSubStatusId)) {
          // if workflow is in either 1, 12 or 55 check if planned date is past current date
          // 1 = new, 12 = AOR Draft, 55 = Rejected, 11 = AOR rejected

          const plannedDate = new Date(item.AddItems.PlannedDeliveryDate).toDateString();
          const today = new Date().toDateString();

          if (new Date(plannedDate) < new Date(today)) {
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.PlannedDeliveryDate]);
          }
        }
        if (item.AddItems.isCOTS == null) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have COTS selected.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.CotsCustomised]);
        }
        if (item.AddItems.ItemDescription == null) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have item description selected.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Detail, [ItemFieldName.ItemDesc]);
        }

        // Item Validation

        if (item.ItemPrice.Quantity == null || item.ItemPrice.Quantity == 0) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a quantity stated.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, [ItemFieldName.Quantity]);
        }
        if (item.ItemPrice.UnitPrice == null || item.ItemPrice.UnitPrice == 0) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a Unit Price.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, [ItemFieldName.UnitPrice]);
        }
        if (isNumber(item.ItemPrice.UnitPrice) && isNumber(item.ItemPrice.Quantity) && isNumber(item.ItemPrice.UnitsPerQuantity) && item.ItemPrice.UnitsPerQuantity > 0) {
          let itemPrice = (item.ItemPrice.UnitPrice * item.ItemPrice.Quantity) / item.ItemPrice.UnitsPerQuantity
          if (itemPrice < 0.01)
            // this.validatedDraftMsgs.push({
            //   message:
            //     'An item has a price less than $0.01.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, ['Unit price - less than $0.01.']);
        }
        if (
          item.ItemPrice.Currency.value == null ||
          item.ItemPrice.Currency.value == ''
        ) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a currency stated.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, [ItemFieldName.Currency]);
        }
        if (
          item.ItemPrice.UnitsPerQuantity == null ||
          item.ItemPrice.UnitsPerQuantity == 0
        ) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a PER stated.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, [ItemFieldName.UnitPerQuantity]);
        }
        if (item.ItemPrice.UnitOfMeasurement.value == '') {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'An item does not have a UOM selected.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Price, [ItemFieldName.MeasurementUnit]);
        }
        // Budget Validation
        if (item.BudgetAllocation.length < 1) {
          // this.validatedDraftMsgs.push({
          //   message:
          //     'Please add at least one Budget Allocation.', category: ValidationErrorCategory.ItemVendor
          // });
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, ['Please add at least one Budget Allocation.']);
        }
        if (item.BudgetAllocation.filter((budget) => budget.BudgetType.value.toLowerCase() == "operating" && !budget.isDeleted && !budget.Strikethrough).length > 0 &&
          (item.BudgetAllocation.filter((budget) => budget.BudgetType.value.toLowerCase() == "capital" && !budget.isDeleted && !budget.Strikethrough).length > 0 ||
            item.BudgetAllocation.filter((budget) => budget.BudgetType.value.toLowerCase() == "capital auc" && !budget.isDeleted && !budget.Strikethrough).length > 0)
        ) {
          // ops and cap/cap auc cannot be tgt condition
          // this.validatedDraftMsgs.push({
          //   message:
          //     'A combined usage of Operating and Capital/Capital AUC budget in a single item is not allowed.', category: ValidationErrorCategory.ItemVendor
          // })
          this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, ['A combined usage of Operating and Capital/Capital AUC budget in a single item is not allowed.']);
        }

        let capitalUsageCheck: boolean = false;
        item.BudgetAllocation.forEach((budget, index) => {
          if (budget.isDeleted || budget.Strikethrough) return;
          if (
            budget.BudgetType.value == null ||
            budget.BudgetType.value == ''
          ) {
            // this.validatedDraftMsgs.push({
            //   message:
            //     'A budget does not have budget type selected.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.BudgetType]);
          }
          if (budget.BudgetType.value.trim().toLowerCase() == 'operating' && missingCostCenterFields(budget)) {
            // this.validatedDraftMsgs.push({
            //   message:
            //     'A budget does not have cost centre selected.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.CostCentre]);
          }
          if (missingGLFields(budget)) {
            // this.validatedDraftMsgs.push({
            //   message:
            //     'A budget does not have G/L account selected.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.GLAccount]);
          }
          if (budget.BudgetType.value.trim().toLowerCase() !== 'project' && missingBudgetExpenditureUsage(budget)) {
            // this.validatedDraftMsgs.push({
            //   message:
            //     'A budget does not have expenditure usage selected.', category: ValidationErrorCategory.ItemVendor
            // });
            this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Budget, [ItemFieldName.BudgetExpenditure]);
          }
          console.log('console log for RO', this.form.isProjectRORequired);
          if (this.form.isProjectRORequired) {
            this.validatedDraftMsgs.push({
              message:
                'Approving Officer Selection is required for Project Budget', category: ValidationErrorCategory.ItemVendor
            });
          }
          if (
            (budget.BudgetFrequencyUsage?.value == null &&
              budget.BudgetType.value.trim().toLowerCase() == 'operating' &&
              budget.BudgetExpenditureUsage?.value != 'Unbudgeted') ||
            (budget.BudgetFrequencyUsage?.value == '' &&
              budget.BudgetType.value.trim().toLowerCase() == 'operating' &&
              budget.BudgetExpenditureUsage?.value != 'Unbudgeted')
          ) {
            this.validatedDraftMsgs.push({
              message:
                'A budget does not have frequency usage selected.', category: ValidationErrorCategory.ItemVendor
            });
          }
          //capital and capital AUC validation
          if (budget.BudgetType.value.trim().toLowerCase() == 'capital' || budget.BudgetType.value.trim().toLowerCase() == 'capital auc') {
            // if(( item.AddItems.EstimatedUsageId === null || !item.AddItems.EstimatedUsageId?.EstimatedUsageId)
            //   || item.AddItems.IsAdditionalSpaceRequired === null 
            //   || item.AddItems.AnnualMaintenanceCost === null
            //   ||  item.AddItems.IsSupportingNonFundingProject === null
            //   || (item.AddItems.IsSupportingNonFundingProject === true && (item.AddItems.SupportingInformation === null || item.AddItems.SupportingInformation === "") )
            // ){
            //     capitalUsageCheck = true;
            // }
            if (item.AddItems.EstimatedUsageId === null || !item.AddItems.EstimatedUsageId?.EstimatedUsageId) {
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Capital, [ItemFieldName.EstUsageOfAsset]);
            }
            if (item.AddItems.IsAdditionalSpaceRequired === null) {
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Capital, [ItemFieldName.AdditionalSpace]);
            }
            if (item.AddItems.AnnualMaintenanceCost === null) {
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Capital, [ItemFieldName.AnnualMaintenance]);
            }
            if (item.AddItems.IsSupportingNonFundingProject === null) {
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Capital, [ItemFieldName.ItemSupportCoFunding]);
            }
            if (item.AddItems.IsSupportingNonFundingProject === true && (item.AddItems.SupportingInformation === null || item.AddItems.SupportingInformation === "")) {
              this.itemErrorService.setItemErrorDetails(item.AddItems.displayItemNumber, ItemTabName.Capital, [ItemFieldName.ReasonCoFunding]);
            }
          }
        });
        // if (capitalUsageCheck) {
        //   let errorMessageCapitalUsage = `Please review the capital usage requirements for the affected item no. records: ${item.AddItems.displayItemNumber}`;
        //   this.validatedDraftMsgs.push({
        //     message: errorMessageCapitalUsage,
        //     category: ValidationErrorCategory.ItemVendor
        //   });
        // }
      }

      if (blockedAirTicketItemNumbers.length > 0) {
        this.validatedDraftMsgs.push({
          message: `Please remove items that are of air tickets material sub group for the affected item no. records: ${blockedAirTicketItemNumbers.join(", ")}`,
          category: ValidationErrorCategory.ItemVendor
        });
      }
      const itemErrorList = this.itemErrorService.getItemKeys();
      if (itemErrorList.length > 0)
        this.validatedDraftMsgs.push({
          message: `Please modify the affected item no. records:<b> ${Array.from(itemErrorList).join(', ')}</b>`, category: ValidationErrorCategory.ItemVendor
        });

    }
    this.validateProjectBudgets();

    let isRFS = false;
    let isReffered = false;

    if (this.purchaseType === 'rfq' || this.purchaseType === 'corporatecard') {
      isReffered = this.checkForReferenceID(this.form.ItemList);
      isRFS = this.form.parentDocumentNo ? false : await this.checkForSourcing(this.form.ItemList);
      // Vendor Validation
      if (this.form.VendorsToSource.filter(item => !item.isDeleted && !item.Strikethrough)?.length < 1 && !isRFS && !this.form.isRFSEnabled) {
        this.validatedDraftMsgs.push({
          message:
            'Please select at least one vendor.', category: ValidationErrorCategory.ItemVendor
        });
      }
    } else {
      if (this.form.VendorsToSource.filter(item => !item.isDeleted && !item.Strikethrough)?.length < 1) {
        this.validatedDraftMsgs.push({
          message:
            'Please select at least one vendor.', category: ValidationErrorCategory.ItemVendor
        });
      }
    }
    // WOC validation

    console.log(this.form.VendorsToSource, "check vendor")
    if (this.form.VendorsToSource.filter(item => !item.isDeleted && !item.Strikethrough)?.length === 1) {
      let totalPrice = this.calculateTotalAmount(this.form.ItemList);
      if (totalPrice > 6000) {
        const reasonId = this.form.WoCReason?.id?.toString();
        if (!isRFS || isReffered) {
          if (!reasonId) {
            this.validatedDraftMsgs.push({
              message:
                'Please select a reason for waiver of competition', category: ValidationErrorCategory.ItemVendor
            });
          } else {
            if (
              this.form.WoCReason?.hasFile &&
              !this.form.WOCFileReferenceNumber
            ) {
              this.validatedDraftMsgs.push({
                message:
                  'Please select a file reference for selected WOC reason', category: ValidationErrorCategory.ItemVendor
              });
            }
            if (
              this.form.WoCReason?.isWOCRequired &&
              !this.form.WOCJustification
            ) {
              this.validatedDraftMsgs.push({
                message:
                  'Please fill up your justification for waiver of competition', category: ValidationErrorCategory.ItemVendor
              });
            }
          }
        }
      }

    }

    //DOTP validation
    let vendorsLength = this.calculateVendorsLength(this.form.VendorsToSource);
    let totalEstAmount = this.calculateTotalAmount(this.form.ItemList)

    let convertedTotalItemList = await this.returnItemListInSGD(this.form.ItemList);
    let totalEstAmountConverted = this.calculateTotalAmount(convertedTotalItemList);
    //RFQ business rule on 200k value
    if ((this.purchaseType == 'rfq' || this.purchaseType == 'corporatecard' || this.purchaseType == 'permissiblecoveringpurchaseorder') && totalEstAmountConverted > 200000) {
      let budgetAllocation = this.form.ItemList.flatMap(x => x.isDeleted || x.Strikethrough ? [] : x.BudgetAllocation).filter(x => !x.isDeleted && !x.Strikethrough && x.BudgetType.value == 'Operating' && x.BudgetExpenditureUsage?.value == 'Budgeted' && x.BudgetFrequencyUsage?.value == 'Recurrent')
      if (budgetAllocation.length == 0)
        this.validatedDraftMsgs.push({
          message: `If your estimated total amount exceed SGD 200,000.00, please raise a Tender in my Purchase or Exceptional PO in MMS.`,
          category: ValidationErrorCategory.ItemVendor
        });
    }

    let CapitalBuyItemUnitPriceThreshold = await this.getSystemConfiguration('PO_capitalbuyitemunitpricethreshold');
    let totalEstAmountForCapital = this.calculateTotalAmountForCapital(this.form.ItemList, CapitalBuyItemUnitPriceThreshold)
    if (totalEstAmountForCapital) {
      this.validatedDraftMsgs.push({
        message: `The system requires that the Unit Price for Capital budget type must be more than or equal to ${CapitalBuyItemUnitPriceThreshold}.`,
        category: ValidationErrorCategory.ItemVendor
      });
    }

    if (this.form.PurchaseTypeId === 5) {
      const dotpReasonId = this.form.DoTPReason?.id?.toString();
      if (vendorsLength === 1 && totalEstAmountConverted > 200000 && !dotpReasonId) {
        this.validatedDraftMsgs.push({
          message:
            'Please select a reason for dispensation of tendering procedures.', category: ValidationErrorCategory.ItemVendor
        });
      } else if (vendorsLength === 1 && totalEstAmountConverted > 200000 && !this.form.DOTPJustification) {
        this.validatedDraftMsgs.push({
          message:
            'Please fill up your justification for dispensation of tendering procedures.', category: ValidationErrorCategory.ItemVendor
        });
      }
    }

    // Vendor length Validation
    if (this.purchaseType == 'dc' && vendorsLength > 1) {
      this.validatedDraftMsgs.push({
        message:
          'Only one vendor is allowed for Direct Contracting.', category: ValidationErrorCategory.ItemVendor
      });
    }
    if (this.purchaseType == 'tender' &&  this.form.documentSubStatusId === DocumentSubStatus.Sow_Draft && vendorsLength < 2) {
      this.validatedDraftMsgs.push({
        message:
          'At least 2 vendors is required for competitive tender.', category: ValidationErrorCategory.ItemVendor
      });
    }
    // Vendor has no email address. 
    if (this.purchaseType == 'rfq' && this.form.generalForm.reasonForNotUsingRFQ.id === environment.optForRFQReasonCode) {
      let checkEmailValidation = validateVendorsEmailRO(this.form.VendorsToSource);
      if (!checkEmailValidation) {
        this.validatedDraftMsgs.push({
          message:
            'Please indicate a vendor email address.', category: ValidationErrorCategory.ItemVendor
        });
      }
    }


    // Type of requisition Validation
    if ((this.purchaseType == 'dc' || this.purchaseType === 'tender') && !this.form.generalForm?.typeOfRequisition?.id) {
      this.validatedDraftMsgs.push({
        message:
          'Please select type of requisition.', category: ValidationErrorCategory.BasicInformation
      });
    }

    // Purchase Title Validation
    if ((this.purchaseType == 'dc' || this.purchaseType === 'tender') && !this.form.generalForm?.purchaseTitle) {
      this.validatedDraftMsgs.push({
        message:
          'Please add title of purchase.', category: ValidationErrorCategory.BasicInformation
      });
    }

    // attachment type
    let isSOWAttached = false;
    let isVendorQuotationAttached = false;
    let isRestrictedITProductSDAttached = false;
    let isRestrictedITProductSDCDOAttached = false;
    let isAttachedTagItems = false;
    let isRemovedAttachmentPurpose = false;
    let isTenderItem = false;
    if (this.purchaseType != 'tender' && this.purchaseType != 'dc') {
      isSOWAttached = true;
      isTenderItem = true;
    }

    if (this.purchaseType != 'corporatecard' && this.purchaseType != 'rfq') {
      isVendorQuotationAttached = true;
    }

    const isPurchaseTypeForRestrictedIT =
      this.purchaseType &&
      [
        'rfq',
        'corporatecard',
        'tender',
        'dc',
        'permissiblecoveringpurchaseorder',
      ].includes(this.purchaseType);

    const restrictedITItems = this.form.ItemList.filter((item) => {
      return (
        item.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase().includes(
          'cat'
        )
      );
    });

    // If ALL Restricted IT Product items belong to Cat 1, only SD attachment required
    const isRestrictedITSDRequired =
      isPurchaseTypeForRestrictedIT &&
      restrictedITItems.length > 0 &&
      restrictedITItems.every(
        (item) =>
          item.AddItems.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase() ===
          'cat1'
      );
    // If some Restricted IT Product items belong to Cat 2, SD & CDO attachment required (stricter)
    const isRestrictedITSDCDORequired =
      isPurchaseTypeForRestrictedIT &&
      restrictedITItems.length > 0 &&
      restrictedITItems.some(
        (item) =>
          item.AddItems.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase() ===
          'cat2'
      );
    if (!isTenderItem && this.purchaseType != 'dc') {
      if (this.form.TenderItem == null) {
        this.validatedDraftMsgs.push({
          message:
            "Please add Target Schedule date and Delivery Address.", category: ValidationErrorCategory.ItemVendor
        })
      } else if (this.form.TenderItem?.TargetScheduleDate === null) {
        this.validatedDraftMsgs.push({
          message:
            "Please add Target Schedule date.", category: ValidationErrorCategory.ItemVendor
        })
      }
      else if (this.form.TenderItem?.DeliveryAddress?.id === "" || this.form.TenderItem?.DeliveryAddress?.value === "") {
        this.validatedDraftMsgs.push({
          message:
            "Please add Delivery Address.", category: ValidationErrorCategory.ItemVendor
        })
      }
      else if (this.form.TenderItem?.DeliveryAddress?.id === "others" && this.form.TenderItem?.PleaseSpecify === "") {
        this.validatedDraftMsgs.push({
          message:
            "Please add Delivery Address for others.", category: ValidationErrorCategory.ItemVendor
        })
      }
    }
    if (!isTenderItem && this.purchaseType == 'dc') {
      if ((this.form.TenderItem && (this.form.TenderItem?.DeliveryAddress?.id === "" || this.form.TenderItem?.DeliveryAddress?.value === "")) || !this.form.TenderItem) {
        this.validatedDraftMsgs.push({
          message:
            "Please add Delivery Address", category: ValidationErrorCategory.ItemVendor
        })
      }
      else if (this.form.TenderItem?.DeliveryAddress?.id === "others" && this.form.TenderItem?.PleaseSpecify === "") {
        this.validatedDraftMsgs.push({
          message:
            "Please add Delivery Address for others.", category: ValidationErrorCategory.ItemVendor
        })
      }
    }
    if (environment.budgetAvailabilityCheck) {
      if (this.purchaseType === 'tender' || this.purchaseType === 'dc') {
        await this.validateBudgetAllocationsFromSAP();
      }
    }
    let attachments = this.attachmentComponent.getAttachments();

    if(attachments.some((item) => item.AttachmentTypeId === 1) && this.purchaseType == 'rfq') {
      const sumOfDocumentToVendorFiles = attachments.filter((item) => item.AttachmentTypeId === 1).reduce((total, cur) =>  total + Number(cur.FileSize), 0);
      if(environment.maxDocumentToVendorOverallDocumentSizeInMB < Math.round(sumOfDocumentToVendorFiles * 100 + Number.EPSILON ) / 100) {
        
        this.validatedDraftMsgs.push({
          message: `Please ensure that the total file size of attachments tagged to "Document to Vendor" does not exceed ${environment.maxDocumentToVendorOverallDocumentSizeInMB}MB`, 
          category: ValidationErrorCategory.Attachments
        });
      }
    }

    for (const attachment of attachments) {
      if (attachment.AttachmentTypeId == 0) {
        this.validatedDraftMsgs.push({
          message:
            `attachment ${attachment.FileName} 's purpose is not selected yet.`, category: ValidationErrorCategory.Attachments
        });
      }
      if (attachment.AttachmentTypeId == 1 && attachment.Strikethrough === false && attachment.isDeleted === false && this.form.isRFSEnabled) {
        if (attachment.TaggedItems && attachment.TaggedItems.length <= 0) {
          console.log("attachment TaggedItems length", attachment.TaggedItems.length)
          isAttachedTagItems = true
        }
      }

      // check if purchase type is tender or direct contract
      if ((this.purchaseType == 'tender' || this.purchaseType == 'dc') 
        // and if have Scope of Work(SOW)
        && attachment.AttachmentTypeId == 3 
        // and is not deleted
        && !(attachment.Strikethrough || attachment.isDeleted)
      ) {
        isSOWAttached = true;
      }


      if ((this.purchaseType == 'corporatecard' || this.purchaseType == 'rfq') && attachment.AttachmentTypeId == 22) {
        isVendorQuotationAttached = true;
      }

      if (
        attachment.AttachmentTypeId ===
        AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD &&
        !attachment.Strikethrough &&
        !attachment.isDeleted
      ) {
        isRestrictedITProductSDAttached = true;
      }

      if (
        attachment.AttachmentTypeId ===
        AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD_CDO &&
        !attachment.Strikethrough &&
        !attachment.isDeleted
      ) {
        isRestrictedITProductSDCDOAttached = true;
      }
      if (attachment.AttachmentTypeId == 1 && attachment.Strikethrough === false && attachment.isDeleted === false && this.purchaseType === 'rfq' && this.form.generalForm.reasonForNotUsingRFQ.id !== environment.optForRFQReasonCode) {
        isRemovedAttachmentPurpose = true;
      }
    }
    if (isRemovedAttachmentPurpose) {
      this.validatedDraftMsgs.push({
        message: 'Please remove all documents with a purpose of "Document to vendor".', category: ValidationErrorCategory.Attachments
      })
    }

    if (isAttachedTagItems) {
      this.validatedDraftMsgs.push({
        message:
          `Please ensure that all documents with a purpose of "Document to vendor" are tagged to one or more items.`, category: ValidationErrorCategory.Attachments
      });
    }

    if (!isVendorQuotationAttached && this.purchaseType == 'corporatecard' && !this.form.isRFSEnabled && !isReffered) {
      this.validatedDraftMsgs.push({
        message:
          "Please attach a file for vendor quotation.", category: ValidationErrorCategory.Attachments
      });
    } 
    // else if (!isVendorQuotationAttached && this.purchaseType == 'rfq' && !this.form.isRFSEnabled && !isReffered) {
    //   let convertedItemPriceList = await this.returnItemListInSGD(this.form.ItemList)
    //   let totalItemPrice = this.calculateTotalAmount(convertedItemPriceList)
    //   if (totalItemPrice >= 6000) {
    //     let isCOTS = this.form.ItemList.filter(x => !x.isDeleted && !x.Strikethrough).every((item: any) => item.AddItems.isCOTS?.value === 'COTS');
    //     if (isCOTS) {
    //       this.validatedDraftMsgs.push({
    //         message:
    //           "Please attach a file for vendor quotation.", category: ValidationErrorCategory.Attachments
    //       });
    //     }
    //   }
    // }

    if (!isSOWAttached) {
      this.validatedDraftMsgs.push({
        message:
          "At least one Scope Of Work document must be attached in this form.", category: ValidationErrorCategory.Attachments
      })
    }

    if (
      !isRestrictedITSDCDORequired &&
      isRestrictedITSDRequired &&
      !isRestrictedITProductSDAttached
    ) {
      this.validatedDraftMsgs.push({
        message:
          'Please attach supporting document for Restricted IT Product: SD Approval.',
        category: ValidationErrorCategory.Attachments,
      });
    }

    if (isRestrictedITSDCDORequired && !isRestrictedITProductSDCDOAttached) {
      this.validatedDraftMsgs.push({
        message:
          'Please attach supporting document for Restricted IT Product: SD & CDO Approval.',
        category: ValidationErrorCategory.Attachments,
      });
    }

    if (!isRestrictedITSDRequired && isRestrictedITProductSDAttached) {
      this.validatedDraftMsgs.push({
        message:
          'Please remove attachment for document regarding Restricted IT Product: SD Approval.',
        category: ValidationErrorCategory.Attachments,
      });
    }
    if (!isRestrictedITSDCDORequired && isRestrictedITProductSDCDOAttached) {
      this.validatedDraftMsgs.push({
        message:
          'Please remove attachment for document regarding Restricted IT Product: SD & CDO Approval.',
        category: ValidationErrorCategory.Attachments,
      });
    }

    let returnMsgs = this.removeDuplicateErrorMessages(this.validatedDraftMsgs);
    if (returnMsgs.length > 0) {
      let finalMessageInHtml: string = this.returnFinalMessageInHtml(returnMsgs)
      this.bannerService.addMessage({ content: finalMessageInHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
    } else {
      this.bannerService.clearValidationMessages()
      setTimeout(() => {
        if (showSnackbar && this.loaders.length <= 0 && returnMsgs.length == 0) {
          this.openSnackBar("validated successfully.");
        }
      }, 2000);
    }

    this.releaseLoader("validateMyPurchase");
    // this.showLoader = false;
    return returnMsgs;
  }

  removeDuplicateErrorMessages(arr: ValidationErrorMessage[]): ValidationErrorMessage[] {
    return arr.reduce((acc:ValidationErrorMessage[], current:ValidationErrorMessage) => {
      // Check if the combination of `id` and `category` already exists in the accumulator
      const exists = acc.some((item:ValidationErrorMessage) => item.category === current.category && item.message === current.message);
      if (!exists) {
        acc.push(current); // Add the current item if it doesn't exist already
      }
      return acc;
    }, []);
  }

  async generateWorkflowForDraftDocument() {
    try {
      this.store.dispatch(incrementLoading({ context: 'generateWorkflow' }));
      let draftType = this.form.documentStatusId == 2 || this.form.documentStatusId == 3
      console.log('drafttype', draftType)
      if (draftType && this.mpNumber) {
        this.mpNumber$.subscribe(async (mpNumber) => {
          if (mpNumber) {
            const result = await lastValueFrom(this.backEndService.generateWorkflowForDraftDocument(this.mpNumber, this.form.generalForm.RO.id))
            this.updatedCurrentWorkflowHistory = result;
            this.currentWorkflowService.updateWorkflow(result);
          }
        });
      }
    }
    catch (Error: unknown) {
      console.error('Error generating workflow for draft');
      this.isGenerateWorkflowError = true;
    }
    finally {
      this.store.dispatch(decrementLoading({ context: 'generateWorkflow' }));
    }
  }
  returnFinalMessageInHtml(validatedErrorMessage: ValidationErrorMessage[]) {
    let result = 'Please correct the errors in the following tabs, and then validate at the document level to see the latest changes:'
    let basicErrMessages = validatedErrorMessage.filter(x => x.category == ValidationErrorCategory.BasicInformation).map(x => x.message)
    if (basicErrMessages.length > 0) {
      result += `<br><b>Basic information</b><br><ul><li>${basicErrMessages.join('</li><li>')}</ul></li>`
    }
    let itemErrMessages = validatedErrorMessage.filter(x => x.category == ValidationErrorCategory.ItemVendor).map(x => x.message)
    if (itemErrMessages.length > 0) {
      result += `<br><b>Item / Vendor</b><br><ul><li>${itemErrMessages.join('</li><li>')}</ul></li>`
    }
    let attachmentErrMessages = validatedErrorMessage.filter(x => x.category == ValidationErrorCategory.Attachments).map(x => x.message)
    if (attachmentErrMessages.length > 0) {
      result += `<br><b>Attachments</b><br><ul><li>${attachmentErrMessages.join('</li><li>')}</ul></li>`
    }
    return result
  }
  calculateVendorsLength(vendorsArray: any) {
    let filteredItems = vendorsArray.filter((vendor: any) => !vendor.isDeleted && !vendor.Strikethrough);
    return filteredItems.length;
  }

  calculateTotalAmount(itemList: any) {
    let totalPrice = 0;
    for (let i = 0; i < itemList.length; i++) {
      if (!itemList[i].isDeleted && !itemList[i].Strikethrough) {
        totalPrice += (itemList[i].ItemPrice.UnitPrice * itemList[i].ItemPrice.Quantity) / itemList[i].ItemPrice.UnitsPerQuantity;
      }
    }
    return totalPrice;
  }

  calculateTotalAmountForCapital(itemList: any, totalUnitPriceThreshold: number) {
    console.log("itemList", itemList)
    for (let i = 0; i < itemList.length; i++) {
      if (!itemList[i].isDeleted && !itemList[i].Strikethrough) {
        for (let j = 0; j < itemList[i].BudgetAllocation.length; j++) {
          if (itemList[i].BudgetAllocation[j].BudgetType.id == 'Capital') {
            let totalUnitPriceThresholdNumber = Number(totalUnitPriceThreshold);
            let convertItemListToNumber = Number(itemList[i].ItemPrice.UnitPrice);
            if (convertItemListToNumber < totalUnitPriceThresholdNumber) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  checkForReferenceID(itemList: any) {
    let isReferenced = itemList.some((item: any) => item.AddItems.ReferenceId);
    return isReferenced;
  }

  async checkForSourcing(itemList: any) {
     const filteredItemList = itemList.filter((item: any) => !item.isDeleted && !item.Strikethrough);
    let isCOTS = filteredItemList.every((item: any) => item.AddItems.isCOTS?.value === 'COTS');
    console.log("isCOTS : ", isCOTS);

    let totalPrice = 0;
    if (isCOTS) {
        for (let i = 0; i < filteredItemList.length; i++) {
            totalPrice += (filteredItemList[i].ItemPrice.UnitPrice * filteredItemList[i].ItemPrice.Quantity) / filteredItemList[i].ItemPrice.UnitsPerQuantity;
        }
    }
    if ((isCOTS && totalPrice > 6000) && ( (this.purchaseType === 'rfq' && this.form?.generalForm?.reasonForNotUsingRFQ?.value === environment.optForRFQReasonCode) || this.purchaseType === 'corporatecard')) {
      return true
    }
    return false;
  }

  async validateExcoBoardDocumentReferences() {

    let areSupportingDocumentsAttached = this.areSupportingDocumentsAttached()
    if (areSupportingDocumentsAttached) return
    const budgetAllocations = []
    for (const item of this.form.ItemList) {
      if (!item.isDeleted && !item.Strikethrough) {
        for (const budget of item.BudgetAllocation) {
          if (!budget.isDeleted && !budget.Strikethrough)
            budgetAllocations.push(budget)
        }
      }
    }
    let convertedItemListToSgd = await this.returnItemListInSGD(this.form.ItemList);
    const operatingBudgetAllocations = getOperatingBudgetAllocations(budgetAllocations, convertedItemListToSgd)
    for (const alloc of operatingBudgetAllocations) {
      if (alloc.budgeted == 'Unbudgeted' && alloc.aorAmount > 100000 && alloc.aorAmount <= 500000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a Board approval as you have a unbudgeted operating budget allocation that exceeds SGD 100,000.00', category: ValidationErrorCategory.BasicInformation
        })
      }
      else if (alloc.budgeted == 'Unbudgeted' && alloc.aorAmount > 500000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a EXCO approval as you have a unbudgeted operating budget allocation that exceeds SGD 500,000.00', category: ValidationErrorCategory.BasicInformation
        })
      }
      else if (alloc.budgeted == 'Budgeted' && alloc.reccurent == 'Recurrent' && alloc.aorAmount > 5000000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a EXCO approval as you have a budgeted recurrent operating budget allocation that exceeds SGD 5,000,000.00.', category: ValidationErrorCategory.BasicInformation
        })
      }
      else if (alloc.budgeted == 'Budgeted' && alloc.reccurent == 'Non-recurrent' && alloc.aorAmount > 200000 && alloc.aorAmount <= 1000000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a EXCO approval as you have a budgeted non-recurrent operating budget allocation that exceeds SGD 200,000.00.', category: ValidationErrorCategory.BasicInformation
        })
      }
      else if (alloc.budgeted == 'Budgeted' && alloc.reccurent == 'Non-recurrent' && alloc.aorAmount > 1000000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a Board approval as you have a budgeted non-recurrent operating budget allocation that exceeds SGD 1,000,000.00.', category: ValidationErrorCategory.BasicInformation
        })
      }
    }
    /**
    @deprecated
    Unbudgeted option has been removed
    **/
    const CapitalAllocations = getCapitalAllocations(budgetAllocations, this.form.ItemList)
    console.log("CapitalAllocations", CapitalAllocations)
    for (const alloc of CapitalAllocations) {
      if (alloc.budgeted == 'Unbudgeted' && alloc.budgetType == 'Capital' && alloc.totalAmount > 100000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a Board approval as you have a unbudgeted capital budget allocation that exceeds SGD 100,000.00', category: ValidationErrorCategory.BasicInformation
        })
      }
      if (alloc.budgeted == 'Unbudgeted' && alloc.budgetType == 'Capital AUC' && alloc.totalAmount > 100000) {
        this.validatedDraftMsgs.push({
          message: 'Please reference a Board approval as you have a unbudgeted capital AUC budget allocation that exceeds SGD 100,000.00', category: ValidationErrorCategory.BasicInformation
        })
      }
    }


  }
  async validateBudgetAllocationsFromSAP() {
    const budgetAllocations = [];
    const currentFYEnd = this.itemErrorService.getCurrentFYEnd();
    for (const item of this.form.ItemList) {
      if (!item.isDeleted && !item.Strikethrough && new Date(item.AddItems.PlannedDeliveryDate) <= currentFYEnd) {
        for (const budget of item.BudgetAllocation) {
          if (!budget.isDeleted && !budget.Strikethrough)
            budgetAllocations.push(budget)
        }
      }
    }
    const operatingBudgetAllocations = getOperatingBudgetAllocationsCWithFinancialYear(budgetAllocations, this.form.ItemList)
    console.log("operatingBudgetAllocations", operatingBudgetAllocations);
    for (const alloc of operatingBudgetAllocations) {
      let budgetAvalAmount: number = 0;
      let amount;
      if (alloc.budgetType == 'Operating') {
        let glAccount = alloc.glAccount.split(',')
        let costCentreId = alloc.costCentre.split('-')
        let deliveryDate = `${alloc.EndFinancialYear}0331`
        for (const glAcc of glAccount) {
          let glAccCode = glAcc.split('-')
          console.log("deliveryDate", deliveryDate)
          console.log("glAccCode", glAccCode[0])
          budgetAvalAmount += await this.operatingBudgetAvailable(costCentreId[0].trim(), glAccCode[0].trim(), alloc.orderNo, deliveryDate);
        }
        amount = alloc.totalAmount;
        if (budgetAvalAmount < amount) {
          this.validatedDraftMsgs.push({
            message: `Insufficient budget for ${alloc.budgetType} - ${alloc.costCentre} - FY${alloc.FinancialYear}. Please contact budget holder.`, category: ValidationErrorCategory.ItemVendor
          })
        }
      }

    }
    const capitalBudgetAllocations = getCapitalBudgetAllocationsWithFinancialYear(budgetAllocations, this.form.ItemList)
    for (const alloc of capitalBudgetAllocations) {
      let budgetAvalAmount: number = 0;
      let amount;
      if (alloc.budgetType == 'Capital') {
        let glAccount = alloc.glAccount.split(',')
        let fundCentreId = alloc.fundCentre.split('-')
        let deliveryDate = `${alloc.EndFinancialYear}0331`
        for (const glAcc of glAccount) {
          let glAccCode = glAcc.split('-')
          budgetAvalAmount = await this.capitalBudgetAvailable(fundCentreId[0].trim(), glAccCode[0].trim(), alloc.orderNo, deliveryDate);
        }
        amount = alloc.totalAmount;
        if (budgetAvalAmount < amount)
          this.validatedDraftMsgs.push({
            message: `Insufficient budget for ${alloc.budgetType} - ${alloc.fundCentre} - FY${alloc.FinancialYear}. Please contact budget holder.`, category: ValidationErrorCategory.ItemVendor
          })
      }
    }

    const capitalAUCBudgetAllocations = getCapitalAUCAllocations(budgetAllocations, this.form.ItemList)
    for (const alloc of capitalAUCBudgetAllocations) {
      let budgetAvalAmount: number = 0;
      let amount;
      if (alloc.budgetType == 'Capital AUC') {
        if (alloc.wbsElement) {
          budgetAvalAmount = await this.capitalBudgetAUCAvailable(alloc.wbsElement);
          amount = alloc.totalAmount;
          if (budgetAvalAmount < amount) {
            this.validatedDraftMsgs.push({
              message: `Insufficient budget for ${alloc.budgetType} - ${alloc.costCentre}. Please contact budget holder.`,
              category: ValidationErrorCategory.ItemVendor
            })
          }
        }
      }
    }

    const projectBudgetAllocations = await Promise.all(getProjectBudgetAllocations(budgetAllocations, this.form.ItemList, this.backEndService, this.form.generalForm))
    console.log("projectBudgetAllocations", projectBudgetAllocations)
    for (const alloc of projectBudgetAllocations) {
      let budgetAvalAmount: number = 0;
      let amount;
      if (alloc.budgetType == 'Project') {
        if (alloc.wbsElement) {
          budgetAvalAmount = await this.projectBudgetAvailable(alloc.wbsElement);
          amount = alloc.totalAmount;
          if (budgetAvalAmount < amount) {
            this.validatedDraftMsgs.push({
              message: `Insufficient budget for ${alloc.budgetType} - ${alloc.projectCode}. Please contact budget holder.`, category: ValidationErrorCategory.ItemVendor
            })
          }
        }

      }
    }

  }
  async operatingBudgetAvailable(budgetCostCentreCode: string, GLAccountCode: string, BudgetOrderNo: string, deliveryDate: string) {
    try {
      const table_fp = environment.table_fp;
      const table_cb = environment.table_cb;
      var record: OthersBudget = await lastValueFrom(this.backEndService.checkBudgetOTH("", budgetCostCentreCode, GLAccountCode, BudgetOrderNo, deliveryDate, table_fp, table_cb));
      console.log("BUDGET_AVAL for Operation", record.BUDGET_AVAL)
      return Number(record.BUDGET_AVAL);
    }
    catch (err) {
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  async capitalBudgetAvailable(budgetfundCentreCode: string, GLAccountCode: string, BudgetOrderNo: string, deliveryDate: string) {
    try {
      const table_fp = environment.table_fp;
      const table_cb = environment.table_cb;
      var record: OthersBudget = await lastValueFrom(this.backEndService.checkBudgetOTH(budgetfundCentreCode, "", GLAccountCode, BudgetOrderNo, deliveryDate, table_fp, table_cb));
      console.log("BUDGET_AVAL for Capital", record.BUDGET_AVAL)
      return Number(record.BUDGET_AVAL);
    } catch (err) {
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }
  async capitalBudgetAUCAvailable(orderNo: string) {
    try {
      var record: WBSBudget = await lastValueFrom(this.backEndService.checkBudgetCapitalAUC(orderNo));
      console.log("BUDGET_AVAL for Capital AUC", record.SGD_AVAILABLE)
      return record.SGD_AVAILABLE;
    } catch (err) {
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  formatDate(date: any): string {
    if (date) {
      return this.datePipe.transform(date, 'yyyyMMdd') ?? date;
    }
    return date;
  }
  async projectBudgetAvailable(projectCode: string) {
    try {
      var record: WBSBudget = await lastValueFrom(this.backEndService.checkBudgetProject(projectCode));
      console.log("BUDGET_AVAL for Project", record.SGD_AVAILABLE)
      return record.SGD_AVAILABLE;
    } catch (err) {
      console.log('Error in fetching the data from SAP ', err);
      return 0;
    }
  }

  areSupportingDocumentsAttached() {
    let defaultValue: boolean = false;
    if (this.form.generalForm.areExcoBoardDocumentsAttached.value == 'yes' && this.form.generalForm.excoBoardDocumentArray) {
      for (const attachment of this.form.generalForm.excoBoardDocumentArray) {
        if (!attachment.IsDeleted)
          defaultValue = true
      }
    }
    return defaultValue;
  }

  validateSaveDraft(showSnackbar?: boolean): ValidationErrorMessage[] {
    this.validatedDraftMsgs = [];
    if (this.form.generalForm.purpose == '') {
      this.validatedDraftMsgs.push({
        message: 'Please fill up your purpose of purchase.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.form.generalForm.internal.value == '') {
      this.validatedDraftMsgs.push({
        message: 'Please select an internal security classification level.', category: ValidationErrorCategory.BasicInformation
      });
    }
    if (this.form.generalForm.external.value == '') {
      this.validatedDraftMsgs.push({
        message: 'Please select an external security classification level.', category: ValidationErrorCategory.BasicInformation
      });
    }
    // attachment type
    let attachments = this.attachmentComponent.getAttachments();
    for (const attachment of attachments) {
      if (attachment.AttachmentTypeId == 0) {
        this.validatedDraftMsgs.push({
          message: `Attachment ${attachment.FileName}'s purpose is not selected yet.`, category: ValidationErrorCategory.Attachments
        });
      }
    }

    let returnMsgs = this.validatedDraftMsgs;
    if (returnMsgs.length > 0) {
      let finalMessageInHtml: string = this.returnFinalMessageInHtml(returnMsgs)
      this.bannerService.addMessage({ content: finalMessageInHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
    } else {
      this.bannerService.clearValidationMessages()
      setTimeout(() => {
        if (showSnackbar && this.loaders.length <= 0 && returnMsgs.length == 0) {
          this.openSnackBar("validated successfully.");
        }
      }, 2000);
        }

    this.validatedDraftMsgs = [];
    return returnMsgs;
  }

  async submitMyPurchase() {
    //verify first before save.
    // this.showLoader = true;
    this.setLoader("submitMyPurchase");
    let errorsMsgs = await this.validateMyPurchase(false);
    if (errorsMsgs.length > 0) {
      // this.showLoader = false;
      this.releaseLoader("submitMyPurchase");
      this.openSnackBar('Document failed to submit', "error");
    } else {
      let purchaseData: any = await this.formatDataForSave();
      // check if this is a new document or not
      // if yes call save api first to get mpnumber for uploading attachment
      let isSmallPurchase = this.checkForSmallPurchase(purchaseData);
      if (isSmallPurchase && this.checkForOtherConditionsThatDoNotRequirePO(this.form)) {
        this.dialogConfRef = this.dialog.open(DialogComponent, {
          // height: '300px',
          // width: '650px',
          panelClass: 'item-vendor-dialog',
          hasBackdrop: true,
          data: {
            headerTitle: 'Raise purchase order',
            contentMsg: `Before proceeding, please be advised that as your current purchase amount is less than or equal to SGD 6,000, this document will not be routed for any workflow and be marked as completed upon submit.
            Following after, you may directly raise a purchase order in MMS and reference back this document.`,
            btnNameOne: 'Proceed',
            btnNameTwo: 'Cancel',
            click: () => {
              this.dialogConfRef.close();
              this.submitMyPurchaseForm(purchaseData);
            },
            clickTwo: async () => {
              this.dialogConfRef.close();
              // which loader are we stopping here?
              // this.showLoader = false;
              // clearing entire loader as we dont know who's loader are we closing
              this.clearLoader("clickTwo");
              return;
            },
          },
        });
      } else {
        this.submitMyPurchaseForm(purchaseData);
      }
    }
    this.releaseLoader("submitMyPurchase");
  }

  async updateFileAttachmentsInStore(mpDocNo: string) {
    let fileFormDB: FileInformation[];
    try {
      let data: AttachmentData = await lastValueFrom(
        this.backEndService.getDocumentAttachments(mpDocNo)
      );
      let count = 0
      fileFormDB = data.attachment.map((docs) => {
        let fileAttachment: Attachment = {
          ...docs,
          isDeleted: false,
        };

        if (
          docs.AttachmentTypeId === AttachmentTypeIdEnum.DIRP_APPROVAL &&
          (DocumentStatusToRemoveDIRP.includes(this.form.documentStatusId) ||
            (this.form.documentSubStatusId &&
              DocumentSubStatusToRemoveDIRP.includes(
                this.form.documentSubStatusId
              )))
        ) {
          //TODO: remove this 'if' block once DIRP has been fully deprecated
          fileAttachment.isDeleted = true;
        }

        let fileUpload: AttachmentTableInformation = {
          FileId: count,
          FileName: docs.FileName as string,
          FileLink: docs.Data as string,
          Purpose: docs.AttachmentTypeId.toString(),
          RFQNumber: docs.RFQNumber ?? '-',
          RFQVendorTagged: docs.MPVendorDetailsId
            ? this.form.VendorsToSource.find(
              (vendor) => vendor.MPVendorDetailsId === docs.MPVendorDetailsId
            )?.Name ?? '-'
            : '-',
          TaggedItems: docs.TaggedItems?.join(', '),
          RFSVendorsTagged: '-',
          FileSize: docs.FileSize as string,
          DateUploaded: docs.CreatedOn as Date,
          isPictureFile: false,
          Action: '',
          Strikethrough: docs.Strikethrough,
        };
        count += 1;
        return {
          attachment: fileAttachment,
          tableInformation: fileUpload,
          fromDatabase: true,
          selectedPurpose: fileAttachment.AttachmentTypeId.toString(),
        };
      });
      this.store.dispatch(getAllAttachment({ files: fileFormDB }));
    }
    catch (error: unknown) {
      console.error(error)
    }
  }
  async submitMyPurchaseForm(purchaseData: any) {
    this.setLoader("submitMyPurchaseForm");
    try {
      let purchaseSaveResult: any;
      let transformedPurchaseData: MyPurchaseForm | undefined
      if (!this.form.documentNo || this.form.documentNo == '') {
        purchaseSaveResult = await lastValueFrom(
          this.backEndService
            .saveMyPurchase(purchaseData)
            .pipe(takeUntil(this.destroy$))
        );
        let saveMyPurchaseData: SaveMyPurchase = await lastValueFrom(this.backEndService.getDraft(purchaseSaveResult.MPDocumentNumber));
        transformedPurchaseData = this.formTransformer.transformInverse(saveMyPurchaseData, this.dpOptions);
        this.store.dispatch(updateWholeForm({ form: transformedPurchaseData }));
        // Tagging for item-vendor
        if (transformedPurchaseData.documentNo && (transformedPurchaseData.TaggedGroups || transformedPurchaseData.documentStatusId === 15)) {
          this.tagItemVendorService.setTaggedGroupsIfDocNumberChanged(transformedPurchaseData.documentNo, transformedPurchaseData.TaggedGroups ?? [])
        }
        purchaseData = await this.formTransformer.transform(transformedPurchaseData, this.loggedInUser.userName, this.dpOptions);
      }
      if (this.form.parentDocumentNo) purchaseData.MPReferenceDocument = this.form.parentDocumentNo;
      await this.saveAttachments(purchaseSaveResult);
      const submissionResponse: any = await lastValueFrom(
        this.backEndService
          .submitMyPurchase(purchaseData)
          .pipe(takeUntil(this.destroy$))
      );
      console.log('submit MyPurchase: ', purchaseSaveResult, submissionResponse);
      if (!!submissionResponse.selectionNeeded && submissionResponse.selectionNeeded === true) {
        console.log('submit MyPurchase reselection needed')
        await this.reassignDRO(true)
      }
      else {
        console.log('submit MyPurchase no reselection needed')
        
      this.setLoader("artificialsubmitloader");
        this.openSnackBar('Document has been submitted!');
        setTimeout(() => {
          this.navigateToLandingPage();
          this.releaseLoader("artificialsubmitloader");
        }, 5000);
      }

    } catch (err: any) {
      console.log('Error submitting MyPurchase due to : ', err.message);
      this.bannerService.addMessage({ content: err.error ? err.error.message : err.message as string, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7));
      if (err.status === 500) {
        this.openSnackBar(
          'Document unable to submit. Please contact administrators if the problem persists.',
          "error"
        );
      } else {
        const currentUrl = this.router.url;
        sessionStorage.setItem('lastUrl', currentUrl);
        this.router.navigateByUrl('/wentWrong');
      }
    } finally {
        // clearing entire loader as we dont know who's loader are we closing
        // this.showLoader = false;
      this.releaseLoader("submitMyPurchaseForm");
    }
  }
  checkForOtherConditionsThatDoNotRequirePO(form: MyPurchaseForm) {
    //for rfq, check for less than 6k, check for at least 1 item customised and no quotation attached, proceed to submission straight without showing small purchase dialog
    let attachments = this.attachmentComponent.getAttachments();
    let vendorQuotationAttached: boolean = false
    for (const attachment of attachments) {
      if (this.purchaseType == 'rfq' && attachment.AttachmentTypeId == 22) {
        vendorQuotationAttached = true;
      }
    }
    let totalPrice = 0;
    for (let i = 0; i < form.ItemList.length; i++) {
      if (!form.ItemList[i].isDeleted && !form.ItemList[i].Strikethrough) {
        totalPrice += (form.ItemList[i].ItemPrice.UnitPrice * form.ItemList[i].ItemPrice.Quantity) / form.ItemList[i].ItemPrice.UnitsPerQuantity;;
      }
    }
    if (!this.form.isRFSEnabled && !vendorQuotationAttached && totalPrice <= 6000)
      return false
    else
      return true
  }

  checkForSmallPurchase(form: any) {
    let isSmallPurchase = false;

    let isRFSEnabled = form.isRFSEnabled;
    if (!isRFSEnabled && (form.PurchaseTypeId == 1 || form.PurchaseTypeId == 3 || form.PurchaseTypeId == 9)) {

      let totalPrice = 0;
      for (let i = 0; i < form.itemList.length; i++) {
        if (!form.itemList[i].isDeleted && !form.itemList[i].Strikethrough) {
          totalPrice += (form.itemList[i].itemPrice.EstimateUnitPrice * form.itemList[i].itemPrice.Quantity) / form.itemList[i].itemPrice.Per;
        }
      }
      if (totalPrice <= 6000) {
        isSmallPurchase = true;
      }
    }
    return isSmallPurchase;
  }

  async saveTender() {
    try {
      // this.showLoader = true;
      this.setLoader("saveTender");
      let dataToSend = {
        TenderStartDate: this.form.TenderStartDate ? this.formTransformer.transformToDate(this.form.TenderStartDate, this.form.TenderStartTime) : null,
        TenderEndDate: this.form.TenderEndDate ? this.formTransformer.transformToDate(this.form.TenderEndDate, this.form.TenderEndTime) : null,
        MPDocumentNumber: this.form.documentNo
      }
      let errors: ValidationErrorMessage[] = this.validateSaveDraft(true);
      if (errors.length > 0) {
        this.releaseLoader("saveTender");
        // this.showLoader = false;
        return;
      }
      await this.saveAttachments(null);
      await lastValueFrom(this.backEndService.saveTender(dataToSend))
      this.openSnackBar("Saved successfully");
      setTimeout(() => {
        this.backtoSameRFQRedirect();
      }, 1000);
    } catch (err) {
      this.openDialog([err as string]);
    } finally {
      this.releaseLoader("saveTender");
    }
  }

  validateTender() {

    let returnMsg;
    // attachment type
    let attachments = this.attachmentComponent.getAttachments();
    let attachmentCheck: any = {
      4: false,
      5: false,
      6: false,
      7: false,
      8: false,
    }
    let typeIDToCheckArray = [4, 5, 6, 7, 8]
    for (const attachment of attachments) {
      if (typeIDToCheckArray.includes(attachment.AttachmentTypeId)) {
        attachmentCheck[attachment.AttachmentTypeId] = true
      }
    }

    for (const id of typeIDToCheckArray) {
      if (!attachmentCheck[id]) {
        let message = `At least one attachment of Purpose "${this.dpOptions.CEAttachmentType.find((attach) => attach.id == id.toString())?.value ?? id}" should be attached to this document.`
        this.validatedDraftMsgs.push({
          message: message, category: ValidationErrorCategory.Attachments
        })
      }
    }

    // tender CE start/end date validation
    if (!this.form.TenderStartDate || !this.form.TenderStartTime) {
      this.validatedDraftMsgs.push({
        message: 'Please select tender start date/time', category: ValidationErrorCategory.ItemVendor
      })
    }
    if (!this.form.TenderEndDate || !this.form.TenderEndTime) {
      this.validatedDraftMsgs.push({
        message: 'Please select tender end date/time', category: ValidationErrorCategory.ItemVendor
      })
    }



    returnMsg = this.validatedDraftMsgs;
    if (returnMsg.length > 0) {
      let finalMessageInHtml: string = this.returnFinalMessageInHtml(returnMsg)
      this.bannerService.addMessage({ content: finalMessageInHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
    } else {
      this.bannerService.clearValidationMessages()
      this.openSnackBar("Tender requirements validated successfully.")
    }
    this.validatedDraftMsgs = []
    return returnMsg


  }

  async submitTender() {
    try {
      let errors = this.validateTender()
      if (errors.length > 0) throw errors;
      this.bannerService.clearValidationMessages()
      let commentControl = new FormControl('')
      //open dialog here
      let dialogRef = this.dialog.open(AoActionDialogComponent, {
        data: {
          title: 'Submit',
          inputLabel: 'Comments',
          okBtnLabel: 'Submit',
          commentControl: commentControl,
          isRequired: false,
          buttonHandler: async () => {
            let dataToSend = {
              TenderStartDate: this.form.TenderStartDate ? this.formTransformer.transformToDate(this.form.TenderStartDate, this.form.TenderStartTime) : null,
              TenderEndDate: this.form.TenderEndDate ? this.formTransformer.transformToDate(this.form.TenderEndDate, this.form.TenderEndTime) : null,
              MPDocumentNumber: this.form.documentNo,
              Comments: commentControl.getRawValue() || ''
            }
            dialogRef.close()
            // this.showLoader = true;
            this.setLoader("buttonHandler");
            await this.saveAttachments(null);
            await lastValueFrom(this.backEndService.submitTender(dataToSend))
            this.openSnackBar("Submitted successfully")
            setTimeout(() => {
              // this.showLoader = false;
              this.releaseLoader("buttonHandler");
              this.navigateToLandingPage();
            }, 5000);
          },
        },
      });
    } catch (err: unknown) {
      let errMessages = [err as any].flat()
      this.bannerService.addMessage({ content: this.returnFinalMessageInHtml(errMessages), type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))

    }
    finally {
      // this.showLoader = false;
      // clearing entire loader as we dont know who's loader are we closing
      this.clearLoader("submitTender");
    }
  }

  validateSOW() {

    // for implementation
    return this.validateMyPurchase(true)
  }


  async submitSOW() {
    //verify first before save.
    // this.showLoader = true;
    this.setLoader("submitSOW");
    let errorsMsgs = await this.validateSOW();
    if (errorsMsgs.length > 0) {
      // this.showLoader = false;
      this.releaseLoader("submitSOW");
      this.openSnackBar('Document failed to submit', "error");
    } else {
      this.bannerService.clearValidationMessages()

      let purchaseData: any = await this.formatDataForSave();

      // check if this is a new document or not
      // if yes call save api first to get mpnumber for uploading attachment
      try {
        await lastValueFrom(this.backEndService.saveMyPurchase(purchaseData))
        await this.saveAttachments(null);
        await lastValueFrom(this.backEndService.triggerSOW(this.form.documentNo as string));
        this.openSnackBar('Document has been submitted!');
        setTimeout(() => {
          // clearing entire loader as we dont know who's loader are we closing
          this.clearLoader("submitSOW - setTimeout");
          this.navigateToLandingPage();
        }, 5000);
      } catch (err) {
        console.log('Error submitting MyPurchase due to : ', err);
        this.openSnackBar(
          err as string,
          "error"
        );
        this.bannerService.addMessage({ content: err as string, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
      } finally {
        // this.showLoader = false;
        this.releaseLoader("submitSOW");
      }
    }
  }

  async saveAttachments(purchaseSaveResult: any) {
    try {
      let MPDocumentNumber = purchaseSaveResult ? purchaseSaveResult.MPDocumentNumber : this.form.documentNo
      let attachments: Attachment[] = this.attachmentComponent
        .getAttachments()
        .map((attachment: Attachment) => ({
          ...attachment,
          MPDocumentNumber: purchaseSaveResult ? purchaseSaveResult.MPDocumentNumber : this.form.documentNo,
        }));
      let attachmentResponse: any[] = [];
      for (const attachment of attachments) {
        let apiResponse = await lastValueFrom(
          this.backEndService.uploadAttachment(attachment)
        );
        attachmentResponse.push(apiResponse);
      }
      await this.updateFileAttachmentsInStore(MPDocumentNumber)
    } catch (e) {
      console.log('error saving attachments!!!');
      throw 'error saving attachments. Please recall the document  if it is submitted!!';
    }
  }

  async formatDataForSave() {
    return await this.formTransformer.transform(
      this.form,
      this.loggedInUser.userName,
      this.dpOptions,
    );
  }
  async updateVendors() {
    if (!this.wasVendorsUpdated) {
      this.openSnackBar('No vendor information detected', 'error')
      return
    }
    else {
      await this.saveDraft('Vendor information updated')
      this.wasVendorsUpdated = false
    }
  }
  async createRFQSUmmary() {
    const response: rfqListDropDown[] = await lastValueFrom(this.backEndService.getRFQNumbers(this.form.documentNo!));
    if (response && response.length === 1) {
      if (response[0].RFQSummaryNumber) this.router.navigate(['/rfqSummary/', response[0].RFQSummaryNumber]);
      else {
        const data = {
          MPDocumentNumber: this.form?.documentNo,
          RFQNumber: response[0].RFQNumber,
          fromRoute: pageName.My_Document
        };
        this.router.navigate(['/rfqSummary'], { state: { data: data } });
      }
    } else {
      this.dialog.open(CreateRFQDialogComponent, {
        data: {
          rfqList: response,
          MPDocumentNumber: this.form?.documentNo,
          loggedInUsername: this.loggedInUsername
        }
      });
    }
  }
  async onBreadCrumbButtonClick($event: any) {
    console.log($event);
    switch ($event.actionType as string) {
      case 'update-vendors':
        await this.updateVendors()
        break;
      case 'save-draft':
        await this.saveDraft();
        break;
      case 'generate-rfq':
        await this.generateRFQ();
        break;
      case 'copy-document':
        await this.openCopyDialog();
        break;
      case 'delete-document':
        await this.openDeleteDialog();
        break;
      case 'validate-draft': {
        await this.saveDraft(undefined, 'validate');
        await this.validateMyPurchase(true);
        await this.generateWorkflowForDraftDocument();
        break;
      }
      case 'reassign-dro':
        await this.reassignDRO()
        break;
      case 'upload-quotations':
        await this.uploadAttachments()
        break;
      case 'submit-draft':
        await this.submitMyPurchase();
        break;
      case 'save-tender':
        await this.saveTender();
        break;
      case 'validate-tender':
        this.validateTender();
        break;
      case 'submit-tender':
        await this.submitTender();
        break;
      case 'validate-sow':
        this.validateSOW();
        break;
      case 'submit-sow':
        this.submitSOW();
        break
      case 'create-RFQ-summary':
        this.createRFQSUmmary();
        break
      default:
        // do nothing
        break;
    }
  }
  async reassignDRO(shouldNavigateToLandingPageAfterClosing?: boolean) {
    let response: RecommendingOfficersSelection[] = await lastValueFrom(this.backEndService.getDrosForReselection(this.form.documentNo!))
    let dialogRef = this.dialog.open(DroDialogComponent, {
      // height: '400px',
      // width: '700px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        officerSelection: response,
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        //call post api here
        let payload: officerReselectionDto = {
          purchaseID: this.form.documentNo!,
          actioner: this.loggedInUser.userName,
          ...result
        }
        await lastValueFrom(this.backEndService.reselectDros(payload))
        this.navigateToLandingPage()
      }
      else if (shouldNavigateToLandingPageAfterClosing)
        this.navigateToLandingPage()
    });
  }
  navigateToLandingPage() {
    this.router.navigateByUrl('/land');
  }
  checkIfNavigatedFromSearchPage() {
    let fromSearch = window.localStorage.getItem('fromSearch')
    window.localStorage.removeItem('fromSearch')
    return fromSearch
  }
  returnToPreviousPage = (args: any): void => {
    const fromSearch = this.checkIfNavigatedFromSearchPage()
    if (fromSearch)
      this.router.navigateByUrl(fromSearch);
    else if ((this.edited || this.mpNumber != 'draft') && sessionStorage.getItem('fromPage') === pageName.My_worklist) {
      this.router.navigateByUrl('/worklist');
    } else if ((this.edited || this.mpNumber != 'draft') && sessionStorage.getItem('fromPage') === pageName.My_Document) {
      this.router.navigateByUrl('/land');
    } else {
      this.router.navigateByUrl('/home');
    }
  };

  openSnackBar(notifMsg: string, type: string = 'success') {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: this.verticalPosition,
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 5000,
    });
  }

  isNullValueCheck(strVal: any) {
    if (
      strVal !== undefined &&
      strVal !== null &&
      strVal !== '' &&
      strVal !== 0
    ) {
      return false;
    }
    return true;
  }

  openDialog(data: string[]): void {
    this.dialogRef = this.dialog.open(InfoDialogComponent, {
      height: '600px',
      width: '450px',
      hasBackdrop: true,
      data: {
        errMsgs: data,
      },
    });
  }

  backtoSameRFQRedirect(notToValidate?:boolean) {
    this.router
      .navigateByUrl('/redirect', { skipLocationChange: true })
      .then(() => {
        this.router.navigate(['/purchase/', this.purchaseType, this.mpNumber]);
      });
    if (!notToValidate) this.validateMyPurchase();
  }


  isReadOnly() {
    return isReadOnly(this.form, this.loggedInUsername)
  }


  scrolltop() {
    window.scroll(0, 0);
  }
  
  prevTab() {
    if (this.selectedIndex !== 0) {
      if(this.selectedIndex === 3 && this.isRfqOrCorporatecard && this.isDocumentTypeNewOrDraft) {
        this.selectedIndex -= 2;
      }else {
        this.selectedIndex -= 1;
      }
      this.scrolltop();
    }
  }

  nextTab() {
    if(this.selectedIndex === 1 && this.isRfqOrCorporatecard && this.isDocumentTypeNewOrDraft) {
      this.selectedIndex += 2;
    }else {
      this.selectedIndex += 1;
    }
    this.scrolltop();
  }

  validatePermissibleReasons() {
    //if form purchase type is permissible and none of the above is selected as a permissible reason
    if (this.form.PurchaseTypeId == 9 && (this.form.generalForm.permissibleReason?.id == '22' || this.form.generalForm.permissibleReason?.id == '7')) {
      //a file attachment should be uploaded with the purpose for sd approval selected
      let isValid1 = false;
      const attachments = this.attachmentComponent.getAttachments();
      for (const attachment of attachments) {
        if (attachment.AttachmentTypeId == AttachmentTypeIdEnum.SD_APPROVAL)
          isValid1 = true;
      }
      if (!isValid1 && this.form.generalForm.permissibleReason.id == '22') this.validatedDraftMsgs.push({
        message: "Please attach SD's prior approval as no permissible reason is selected", category: ValidationErrorCategory.Attachments
      })
      if (!isValid1 && this.form.generalForm.permissibleReason.id == '7') this.validatedDraftMsgs.push({
        message: "Please attach AO's prior approval for urgent on site repair", category: ValidationErrorCategory.Attachments
      })
      //other permissible reasons text input field should be filled in
      let isValid2 = false;
      if (this.form.generalForm.otherPermissibleReasons && this.form.generalForm.otherPermissibleReasons.length > 0) {
        isValid2 = true;
      }
      if (!isValid2 && this.form.generalForm.permissibleReason.id == '22') this.validatedDraftMsgs.push({
        message: 'Please enter other permissible reasons in the corresponding text field if no permissible reasons are selected', category: ValidationErrorCategory.Attachments
      })
    }
    if (this.form.PurchaseTypeId == 9 && this.form.generalForm.permissibleReason?.id === undefined) {
      this.validatedDraftMsgs.push({
        message: 'Please fill up the Permissible Reasons', category: ValidationErrorCategory.BasicInformation
      })

    }
  }
  validateQuotations() {
    if (!this.attachmentComponent.wasAttachmentsAdded && !this.attachmentComponent.wasAttachmentsUpdated) {
      this.openSnackBar(
        'No attachment changes detected',
        "error"
      );
      return true
    }
    return false
  }
  async uploadAttachments() {
    //validate here first
    let shouldExit = this.validateQuotations()
    if (shouldExit) return
    // this.showLoader = true;
      this.setLoader("uploadAttachments");
    try {
      if (this.form.documentNo && this.form.PurchaseTypeId == 3) {
        this.dialogConfRef = this.dialog.open(DialogComponent, {
          // height: '230px',
          // width: '650px',
          panelClass: 'item-vendor-dialog',
          hasBackdrop: true,
          data: {
            headerTitle: 'Upload quotation confirmation',
            contentMsg: 'Please check that you have uploaded all quotations. Upon clicking confirm, the document status will turn to completed and can no longer be modified.',
            btnNameOne: 'Confirm',
            btnNameTwo: 'Cancel',
            click: async () => {
              this.dialogConfRef.close();
              await this.saveAttachments(null);
              this.attachmentComponent.wasAttachmentsUpdated = false
              this.attachmentComponent.wasAttachmentsAdded = false
              await lastValueFrom(this.backEndService.completeOnlinePurchase(this.form.documentNo!))
              this.openSnackBar("Quotation attachment updated")
              this.navigateToLandingPage()
              return;
            },
            clickTwo: () => {
              this.dialogConfRef.close();
            },
          },
        });
      }
      else {
        let attachments = this.attachmentComponent.getAttachments();
        this.validatedDraftMsgs = [];
        for (const attachment of attachments) {
          if (
            ((this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
              this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent) ||
              this.form.documentStatusId === DocumentMainStatus.Completed) &&
            !attachment.Strikethrough &&
            !attachment.isDeleted &&
            Number(attachment.AttachmentTypeId) === AttachmentTypeIdEnum.QUOTATION
          ) {
            if (attachment.RFQNumber === undefined || attachment.MPVendorDetailsId === undefined) {
              this.validatedDraftMsgs.push({
                message:
                  `Please ensure that quotation is tagged to a vendor.`, category: ValidationErrorCategory.Attachments
              });
            }
          }
        }
        let returnMsgs = this.validatedDraftMsgs;
        if (returnMsgs.length > 0) {
          let finalMessageInHtml: string = this.returnFinalMessageInHtml(returnMsgs)
          this.bannerService.addMessage({ content: finalMessageInHtml, type: BannerType.error }, this.form.documentNo || (Math.random() + 1).toString(36).substring(7))
        } else {
          await this.saveAttachments(null);
          this.attachmentComponent.wasAttachmentsUpdated = false
          this.attachmentComponent.wasAttachmentsAdded = false
          this.bannerService.clearValidationMessages()
          this.openSnackBar("Quotation attachment updated")
        }

      }
    }
    catch (error: unknown) {
      console.error(error)
      alert('Something went wrong while uploading attachments')
    }
    finally {
      // this.showLoader = false;
      this.releaseLoader("uploadAttachments");
    }
  }

  isDisplayGenerateRFQ() {
    let hasAccess = false;

    // if RFS, only display for PE
    if(this.form.isRFSEnabled) {
      hasAccess = this.form.ItemList.some((item) => item.AddItems.PurchaseExecutive === this.loggedInUsername);
    } else {
      // if not, only RO or creator can view
      hasAccess = this.form.generalForm.RO?.id == this.loggedInUsername || this.loggedInUsername === this.form.createdBy
    }
    const externalClassificationId = this.form.generalForm?.external?.id;
    
    return (
      hasAccess &&
      externalClassificationId &&
      (
        [
          SecurityClassificationId.RESTRICTED,
          SecurityClassificationId.CONFIDENTIAL,
          SecurityClassificationId.SECRET,
        ] as string[]
      ).includes(externalClassificationId) &&
      this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
      this.form.documentSubStatusId ===
      DocumentSubStatus.Awaiting_Rfq_Generation
    );
  }


  async onGenerateRFQ() {
    // this.showLoader = true;
    this.setLoader("onGenerateRFQ");

    try {
      let form: SaveMyPurchase = await this.formTransformer.transform(
        this.form,
        this.loggedInUsername,
        this.dpOptions,
      );
      form.rfqDeadlines = [];
      // Generate RFQ and start deadline countdown
      let response: any = await lastValueFrom(
        this.backEndService.generateRFQ(form)
      );

      // Show success message
      this.openSnackBar(
        'Successfully generated RFQ, please wait for all generated RFQ files to automatically download.'
      );

      // Re-fetching updated data from server and updating the header
      let retrievedForm: SaveMyPurchase = await lastValueFrom(
        this.backEndService.getDraft(this.mpNumber)
      );
      let transFormedRetrievedForm: MyPurchaseForm =
        this.formTransformer.transformInverse(retrievedForm, this.dpOptions);
      this.store.dispatch(updateWholeForm({ form: transFormedRetrievedForm }));

      // Trigger RFQ file(s) download
      const rfqOutput = await this.rfqOutputService.onFetchRfqOutput(
        form.MPDocumentNumber as string
      );
      const rfqItems = rfqOutput?.data?.RFQ;
      if (Array.isArray(rfqItems) && rfqItems.length > 0) {
        const validUploadPaths = rfqItems
          .map((rfqItem) => rfqItem.UploadPath)
          .filter((str) => !!str) as string[];
        const uniqueUploadPaths = new Set(validUploadPaths);
        await this.fileService.downloadFiles(Array.from(uniqueUploadPaths), {
          isOpenInNewTab: true,
        });
      } else {
        this.openSnackBar(
          'Error encountered while downloading the generated RFQs.',
          'error'
        );
      }
    } catch (err) {
      console.log('Error generating RFQ due to : ', err);
      this.openSnackBar('Error encountered while generating RFQ.', 'error');
      this.bannerService.addMessage(
        { content: err as string, type: BannerType.error },
        this.form.documentNo ?? ''
      );
    } finally {
      // this.showLoader = false;
      this.releaseLoader("onGenerateRFQ");
    }
  }

  public get alertType(): typeof AlertType {
    return AlertType
  }
  
  // future enhancement suggestion, create a common module to host common conditions: 
  public get isRfqOrCorporatecard(): boolean {
    return (this.purchaseType === 'rfq' || this.purchaseType === 'corporatecard');
  }
  
  public get isDocumentTypeNewOrDraft(): boolean {
    return (this.form.documentStatusId == 2 || this.form.documentStatusId == 3);
  }
  // end of suggestion
  
  public get disabledItemVendorTagging(): boolean {
    return this.isDocumentTypeNewOrDraft || !Boolean(this.form.isRFSEnabled)
  }

  public setLoader(key: string) {
    console.log("loader added: ", key);
    this.loaders.push(key);
  }
  public releaseLoader(key: string) {
    if(this.loaders.some((item) => item === key)) {
      console.log("loader removed: ", key);
      this.loaders = this.loaders.filter((item) => item != key);
    } else {
      console.warn(`failed to remove loader: ${key}`);
    }
  }

  public clearLoader(key: string) {
    if(this.loaders.length > 0) {
      console.warn(`key: ${key} - force clear remaining loaders: ${this.loaders.join(", ")}`);
    }
    this.loaders = [];
  }

  async getCurrentWorkflow() {
    try {
      let data = await lastValueFrom(
        this.backEndService
          .getCurrentWorkflowHistory(this.mpNumber as string)
          .pipe(takeUntil(this.destroy$))
      );
      if (data.woc && data.woc.length > 0) {
        const wocApproved = data.woc[data.woc.length - 1].Action === 'Approved';
        this.currentWorkflowService.setisWocApproved(wocApproved);
      }
    } catch (e) {
      console.log(e);
      throw Error('Error in record');
    }
  }

}


